import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { Observable, forkJoin, of } from 'rxjs';
import { SelectItem } from 'primeng/api';
import { catchError, map, concatMap, mergeMap, toArray, tap } from 'rxjs/operators';
import { PETICIONES, STORAGE, LS_LANG, DEFAULT_LANG, PARAMETRES, CODE_TOKEN_EXTERNO, TIPO_DATO, CODE_WEBSERVICES, EXTERNAL_ROL, ETIQUETAS, OPTIONAL_LANG, BOOLEAN_OPTION, BASE_HREF } from 'src/app/core/utils/constants';
import { RepositoryService } from 'src/app/core/repositories/repository.service';
import { ParametersService } from 'src/app/core/repositories/parameters.service';
import { StatisticsService } from 'src/app/core/repositories/statistics.service';
import { AuthenticationService } from 'src/app/core/auth/authentication.service';
import { CommentsInternaService } from 'src/app/core/repositories/commentsinterna.service';
import { Wsdefs } from 'src/app/core/entities/wsdefs.model';
import { Permissions } from 'src/app/core/entities/permissions.model';
import { Setvalues } from 'src/app/core/entities/setvalues.model';
import { TokenValid } from 'src/app/core/auth/tokenvalid.model';
import { Webservice } from 'src/app/core/entities/webservice.model';
import { WebservicesParse } from 'src/app/core/entities/webservicesparse.model';
import { Parameters } from 'src/app/core/entities/parameters.model';
import { Xmlfields } from 'src/app/core/entities/xmlfields.model';
import { Statistics } from 'src/app/core/entities/statistics.model';
import { Rols } from 'src/app/core/entities/rols.model';
import { Fieldlinks } from 'src/app/core/entities/fieldlinks.model';
import { Xmldefs } from 'src/app/core/entities/xmldefs.model';
import { WebserviceValorDato } from 'src/app/core/entities/webservicevalordato.model';
import { VistaRapida } from 'src/app/core/entities/vistarapida.models';
import { PersonsByIdNumCtrlDig } from 'src/app/core/entities/personsByIdNumCtrlDig.model';
import { CommentsInterna } from 'src/app/core/entities/commentsinterna.model';
import { BuscadorTramites } from 'src/app/core/entities/buscadortramites.model';
import { Avis } from 'src/app/core/entities/avis.model';
import * as _ from 'lodash';
import { AvisService } from 'src/app/core/repositories/avis.service';
import { Utils } from 'src/app/core/utils/utils';

@Injectable()
export class WebServicesService {

    tramitsbusqueda: string = "";
    numtramitbusqueda: number = 0;
    rol: string = "";
    nif: string = "";
    desc: string = "";
    dboid: string = "";
    idioma: string = "";
    idempresa: string = "";
    ip: string = "";
    accesToken : string = "";
    user: string = "";
    tercer: PersonsByIdNumCtrlDig[] = new Array<PersonsByIdNumCtrlDig>();
    tercerApoyo: PersonsByIdNumCtrlDig[] = new Array<PersonsByIdNumCtrlDig>();
    persons: PersonsByIdNumCtrlDig = new PersonsByIdNumCtrlDig();

    optionsTercer: SelectItem[] = [];
    optionsTercerBase: SelectItem[] = [];

    datagroupAux: any = [];
    auxsetvalues: any = [];
    setvalues: Setvalues[] = new Array<Setvalues>();
    setvaluesBusca: Setvalues[] = new Array<Setvalues>();

    setvaluerol: Setvalues[] = new Array<Setvalues>();
    setvaluesAct: Setvalues[] = new Array<Setvalues>();

    wsdefs: Wsdefs[] = new Array<Wsdefs>();
    wsdefsrol: Wsdefs[] = new Array<Wsdefs>();
    wsvistaprevia: Wsdefs[] = new Array<Wsdefs>();

    permissions: Permissions[] = new Array<Permissions>();
    vista_rapida: Rols = new Rols();

    webservice: Webservice = new Webservice();
    vistaRapidaObj: VistaRapida = new VistaRapida();

    webservicesParse: WebservicesParse[] = new Array<WebservicesParse>();
    webservicesParseBuscador: WebservicesParse[] = new Array<WebservicesParse>();
    webservicesParseBuscadorAux: WebservicesParse[] = new Array<WebservicesParse>();
    webservicesParseDef: WebservicesParse[] = new Array<WebservicesParse>();
    webservicesParseVista: WebservicesParse[] = new Array<WebservicesParse>();
    webserviceVista: WebservicesParse = new WebservicesParse();

    xmldefs: Xmldefs[] = new Array<Xmldefs>();
    fieldLinks: Fieldlinks[] = new Array<Fieldlinks>();
    parameters_code: Parameters = new Parameters();
    validToken: TokenValid = new TokenValid();
    xmlfieldBusca: Xmlfields[] = new Array<Xmlfields>();

    textContacte: boolean = false;
    loadingWS: boolean = true;
    vistaRapida: boolean = false;
    butonOrderColUp: boolean = true;
    butonOrderColDown: boolean = false;
    wsenabledrefresh: boolean = false;
    existNotif: boolean = false;
    existComun: boolean = false;

    viewfactures: boolean = false;
    viewContractes: boolean = false;

    loadingfactures: boolean = true;
    loadingContractes: boolean = true;
    loadingTramite: boolean = true;

    statistics : Statistics = new Statistics();
    isStatistics: boolean = false;

    valorTrue: boolean = true;
    valorFalse: boolean = false;

    isTramite: boolean = false;
    fullBusca: boolean = false;

    comment: CommentsInterna= new CommentsInterna();
    commentsInterna: CommentsInterna[] = new Array<CommentsInterna>();

    arrayVal: WebserviceValorDato[][] = new Array<Array<WebserviceValorDato>>();
    arrayValApoyo: WebserviceValorDato[][] = new Array<Array<WebserviceValorDato>>();
    webQueixas: WebservicesParse = new WebservicesParse();
    webNotific: WebservicesParse = new WebservicesParse();
    webComunic: WebservicesParse = new WebservicesParse();

    allAvisUser: Avis[] = new Array<Avis>();

    buscaTramAll: BuscadorTramites[] = new Array<BuscadorTramites>();
    buscadorTramites: number = 0;

    isNumeric = (value: any): boolean => !isNaN(Number(value));

    constructor(private repositoryService: RepositoryService,
                private parametersService: ParametersService,
                private statisticsService: StatisticsService,
                private datePipe: DatePipe,
                public router: Router,
                private avisService: AvisService,
                private authService: AuthenticationService,
                private commentsInternaService: CommentsInternaService) {
                    this.vistaRapida = false;
                 }

    initView(data: any): Observable<any> {

        this.idempresa = _.cloneDeep(localStorage.getItem(STORAGE.IDEMPRESA) ?? "");
        this.accesToken = _.cloneDeep(localStorage.getItem(STORAGE.TOKENWS) ?? "");
        this.user = _.cloneDeep(localStorage.getItem(STORAGE.USUARIO) ?? "");
        this.ip = _.cloneDeep(localStorage.getItem(STORAGE.IP) ?? "");

        this.buscaTramAll = new Array<BuscadorTramites>();
        this.webservicesParseDef = new Array<WebservicesParse>();
        this.textContacte = false;
        this.loadingWS = true;
        this.vistaRapida = true;
        this.viewfactures = false;
        this.viewContractes = false;
        this.vistaRapidaObj.padroenable = false;
        this.isTramite = false;
        this.buscadorTramites = 0;
        this.tramitsbusqueda = "";
        this.fullBusca = false;

        this.webQueixas = new WebservicesParse();
        this.webNotific = new WebservicesParse();
        this.webComunic = new WebservicesParse();

        if (data != undefined) {

            this.wsdefsrol = new Array<Wsdefs>();
            this.wsvistaprevia = new Array<Wsdefs>();
            this.setvaluerol = new Array<Setvalues>();

            /*Datos recogidos del dialog (busqueda por nº identificacion)*/
            this.nif = data.nif;
            this.rol = data.rol;
            this.desc = data.desc;
            this.dboid = data.dboid;

            /*Variable donde recogemosel idioma */
            this.idioma = localStorage.getItem(LS_LANG) || DEFAULT_LANG;

            this.tercer = _.cloneDeep(data.tercer);
            this.tercerApoyo = _.cloneDeep(data.tercer);

            /*Gestor del selector de tercer*/
            for (let i = 0; i < this.tercer.length; i++) {
                if(this.tercer[i].dboid === this.dboid){
                    this.persons = this.tercer[i];
                }
                this.optionsTercerBase.push({ value: this.tercer[i].dboid, label: this.tercer[i].fullname });
            }
            this.optionsTercer = this.optionsTercerBase;
            this.optionsTercerBase = [];

            /*Variable donde recogemos el token*/
            //let stringToken = localStorage.getItem(STORAGE.VALID_TOKEN) ?? "";
            //this.validToken = JSON.parse(stringToken);
            const stringToken = localStorage.getItem(STORAGE.VALID_TOKEN);
            
            if (stringToken && stringToken.trim() !== "") {
                try {
                    const rawData = JSON.parse(stringToken);
                    
                    this.validToken = new TokenValid();
                    Object.assign(this.validToken, rawData);
                    
                } catch (error) {
                    console.error("Error al parsear el token, el JSON es inválido", error);
                    this.validToken = new TokenValid();
                }
            } else {
            this.validToken = new TokenValid();
            }

            /*registro auditoria consultas de los usuarios interno*/ 
            this.statistics.dates = new Date();
	        this.statistics.users = localStorage.getItem(STORAGE.USUARIO) ?? "";
	        this.statistics.rol = this.rol;
            this.statistics.idnumber = this.nif.toLocaleUpperCase();
            this.statistics.dboid = this.dboid;
            this.statistics.ip = this.ip;

            return forkJoin({
                valor00: this.repositoryService.doGet(PETICIONES.setvalues.findAll),
                valor01: this.repositoryService.doGet(PETICIONES.wsdefs.findAll),
                valor02: this.repositoryService.doGet(PETICIONES.permissions.findAll),
                valor03: this.parametersService.findByCode(CODE_TOKEN_EXTERNO),
                valor04: this.repositoryService.findByCode(PETICIONES.rols.findByCode, this.rol),
                valor05: this.repositoryService.doGet(PETICIONES.fieldlinks.findAll),
                valor06: this.repositoryService.doGet(PETICIONES.xmldefs.findAll),
                valor07: this.statisticsService.postStatistics(this.statistics),
                valor08: this.commentsInternaService.findByDboid(this.dboid),
                valor09: this.avisService.findByDboid(this.dboid),
                valor10: this.repositoryService.doGet(PETICIONES.xmlfields.findAll)}
            ).pipe(map(dataGroup => {

                    this.datagroupAux = dataGroup;
                    this.auxsetvalues = _.cloneDeep(dataGroup.valor00);
                    this.wsdefs = _.cloneDeep(dataGroup.valor01);
                    this.permissions = _.cloneDeep(dataGroup.valor02);

                    /*Recogemos el objeto parametre con el parametro del token (atributo value) para llamar a los WS*/
                    this.parameters_code = _.cloneDeep(dataGroup.valor03 as Parameters);
                    if(this.parameters_code === null){
                        this.loadingWS = false;
                        return null;
                    }

                    this.vista_rapida = _.cloneDeep(dataGroup.valor04);
                    this.fieldLinks = _.cloneDeep(dataGroup.valor05);
                    this.xmldefs = _.cloneDeep(dataGroup.valor06);

                    this.isStatistics = _.cloneDeep(dataGroup.valor07 as boolean);
                    if(this.isStatistics){
                        console.log("consulta de usuario: " + localStorage.getItem(STORAGE.USUARIO) + " al Nº identif: " + this.nif.toLocaleUpperCase());
                    }

                    this.commentsInterna = _.cloneDeep(dataGroup.valor08 as CommentsInterna[]);
                    this.commentsInterna = _.orderBy(this.commentsInterna, 'createdAt').reverse();

                    /**Gestion de los avisos**/
                    let allAvis = new Array<Avis>();
                    this.allAvisUser = new Array<Avis>();
                    allAvis = _.cloneDeep(dataGroup.valor09 as Avis[]);
                    if(allAvis.length > 0){
                        for(let i = 0; i < allAvis.length; i++){
                            if(allAvis[i].avisEstat.id === 3 || allAvis[i].avisEstat.id === 5){
                                if(allAvis[i].avRead === 0){
                                    this.allAvisUser.push(allAvis[i]);
                                }
                            }
                        }
                    }
                    this.allAvisUser = _.orderBy(this.allAvisUser, 'dateCreation').reverse();

                    this.xmlfieldBusca = _.cloneDeep(dataGroup.valor10);

                    //Recogemos los webservices que pertenecen al usuario con el rol seleccionado.
                    for(let i = 0; i < this.permissions.length; i++){
                        if(this.rol === this.permissions[i].rolId.code && this.permissions[i].operationId.code === "GET"){
                            for(let x = 0; x < this.wsdefs.length; x++){
                                /* WS que utilizaremos para formar vista rápida*/
                                if(this.wsdefs[x].online === 1 || this.wsdefs[x].online === 2){
                                    if(this.permissions[i].permissionableId === this.wsdefs[x].id){
                                        this.wsvistaprevia.push(this.wsdefs[x]);
                                    }
                                }
                                /* WS que se verán en el menu de selección de webservices*/
                                if((this.wsdefs[x].online === 1 || this.wsdefs[x].online === 2 ) && (this.wsdefs[x].quickview === 0 || this.wsdefs[x].quickview === 2)){
                                    if(this.permissions[i].permissionableId === this.wsdefs[x].id){
                                        this.wsdefsrol.push(this.wsdefs[x]);
                                    }
                                }
                            }
                        }
                    }

                    /*Creamos un objeto WebservicesParse con todos los ws del rol seleccionado*/
                    this.webservicesParseBuscadorAux = new Array<WebservicesParse>();
                    for(let i = 0; i < this.wsdefsrol.length; i++){
                        this.webservicesParseBuscadorAux .push(new WebservicesParse());
                        this.webservicesParseBuscadorAux [i].cat = _.cloneDeep(this.wsdefsrol[i].cat);
                        this.webservicesParseBuscadorAux [i].esp = _.cloneDeep(this.wsdefsrol[i].esp);
                        this.webservicesParseBuscadorAux [i].code = _.cloneDeep(this.wsdefsrol[i].code);
                        let xmlfield =  new Array<Xmlfields>();
                        let permisos =  new Array<Permissions>();
                        for(let x = 0; x < this.xmlfieldBusca.length; x++){
                            if(this.wsdefsrol[i].xmldef.id === this.xmlfieldBusca[x].xmldefId){
                                for(let y = 0; y < this.permissions.length; y++){
                                    if(this.permissions[y].permissionableType === "Xmlfield" && this.permissions[y].operationId.code === "VIEW"){
                                        if(this.permissions[y].rolId.code === this.rol){
                                            if(this.xmlfieldBusca[x].id === this.permissions[y].permissionableId){
                                                xmlfield.push(this.xmlfieldBusca[x]);
                                                permisos.push(this.permissions[y]);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        this.webservicesParseBuscadorAux [i].etiquetas = _.cloneDeep(xmlfield);
                        this.webservicesParseBuscadorAux [i].permisos = _.cloneDeep(permisos);
                    }

                    /*Recogemos los setvalues que pertenecen al usuario con el rol seleccionado*/
                    var newSetValues: Setvalues[] = [];
                    var lookupObject: Record<number, Setvalues> = {};
                    for(let i = 0; i < this.wsdefsrol.length; i++){
                        this.setvaluerol.push(this.wsdefsrol[i].setvalue);
                    }

                    for(var i in this.setvaluerol) {
                        lookupObject[this.setvaluerol[i].id] = this.setvaluerol[i];
                    }

                    for(var i in lookupObject) {
                        newSetValues.push(lookupObject[i]);
                    }
                    this.setvalues = _.cloneDeep(newSetValues);
                    this.setvalues = _.orderBy(this.setvalues, 'numorder');

                    /**Recogemos en un array los WS con enabled desactivado**/
                    let wsdefsrolenabled= new Array<Wsdefs>();
                    for(let i = 0; i < this.wsvistaprevia.length; i++){
                        if(this.wsvistaprevia[i].enable === 1 || this.wsvistaprevia[i].quickview === 2 || this.wsvistaprevia[i].quickview === 1){
                            wsdefsrolenabled.push(this.wsvistaprevia[i]);
                        }
                    }

                    /**Sacamos fuera el ws de contratos porque no se carga de inicio; lo carga el usuario seleccionadolo **/
                    for(let j = 0; j < wsdefsrolenabled.length; j++){
                        if(wsdefsrolenabled[j].code === CODE_WEBSERVICES.NIOSDISPONIBLESPROV){
                            wsdefsrolenabled.splice(j, 1);
                        }
                        if(wsdefsrolenabled[j].code === CODE_WEBSERVICES.PASFACTULTANYWSI){
                            wsdefsrolenabled.splice(j, 1);
                        }
                    }

                    this.existNotif = false;
                    this.existComun = false;

                    /*Rellenamos el objeto webservice para pasarselo al servidor*/
                    this.webservice.nifcif = this.nif.toLocaleUpperCase();
                    this.webservice.dboid = this.dboid;
                    this.webservice.idioma = localStorage.getItem(LS_LANG) || DEFAULT_LANG;
                    //this.webservice.codEmpresa = PARAMETRES.COD_EMPRESA;
                    this.webservice.codEmpresa = this.idempresa;
                    this.webservice.token = this.parameters_code.value;
                    this.webservice.wsdefs = wsdefsrolenabled;
                    this.webservice.permisos = this.permissions;
                    this.webservice.rol = this.rol;
                    
                    this.webservice.userId = this.user;
                    this.webservice.tokenacces = this.accesToken;

                    /*Pasamos los datos de todos los ws al servidor con un post*/
                    this.repositoryService.doPost(PETICIONES.webservice.doPost, this.webservice).subscribe(data => {
                        this.webservicesParse = this.formatTipoWS(data);

                        /*clonamos el objeto webservicesParse para integralo en la vista rapida*/
                        this.webservicesParseVista = _.cloneDeep(this.webservicesParse);
                        if(this.webservicesParseVista.length > 0){

                            this.vistaRapidaObj.active = true;

                            let numws : number = 0;
                            for(let i = 0; i < this.webservicesParseVista.length; i++){
                              numws++;
                              switch(this.webservicesParseVista[i].code) {
                                case CODE_WEBSERVICES.WSAVISOSHABITANTEPOB: {
                                    let numorden : number = 0;
                                    this.calculoImportes(this.webservicesParseVista, CODE_WEBSERVICES.WSAVISOSHABITANTEPOB, i, numorden, numws, ETIQUETAS.NOMBRE.textcarpcat);
                                    this.calculoImportes(this.webservicesParseVista, CODE_WEBSERVICES.WSAVISOSHABITANTEPOB, i, numorden, numws, ETIQUETAS.NOMBRE.textcarpesp);
                                    
                                    for(let p = 0; p < this.webservicesParse.length; p++){
                                        if(this.webservicesParse[p].code === this.webservicesParseVista[i].code){
                                            this.webservicesParse[p] = _.cloneDeep(this.webservicesParseVista[i]);
                                        }
                                    }
                                    break;
                                }
                                case CODE_WEBSERVICES.TRAMITSPORTALCIUTADA:
                                case CODE_WEBSERVICES.TRAMITSPORTALEMPRESA:
                                case CODE_WEBSERVICES.TRAMITSPORTALPROVEIDOR: {                                                
                                    for(let p = 0; p < this.webservicesParse.length; p++){
                                        if(this.webservicesParse[p].code === this.webservicesParseVista[i].code){
                                            this.webservicesParse[p] = _.cloneDeep(this.webservicesParseVista[i]);
                                        }
                                    }
                                    
                                    this.vistaRapidaObj.totTramit = 0;
                                    if(this.webservicesParseVista[i].valores != null){
                                        this.vistaRapidaObj.totTramit = this.webservicesParseVista[i].valores.length;
                                    }
                                    break;
                                }
                                case CODE_WEBSERVICES.ALTRESSERVEISCIUTADA:
                                case CODE_WEBSERVICES.ALTRESSERVEISEMPRESA:
                                case CODE_WEBSERVICES.ALTRESSERVEISPROVEIDOR: {
                                    for(let p = 0; p < this.webservicesParse.length; p++){
                                        if(this.webservicesParse[p].code === this.webservicesParseVista[i].code){
                                            this.webservicesParse[p] = _.cloneDeep(this.webservicesParseVista[i]);
                                        }
                                    }

                                    this.vistaRapidaObj.totAltres = 0;
                                    if(this.webservicesParseVista[i].valores != null){
                                        this.vistaRapidaObj.totAltres = this.webservicesParseVista[i].valores.length;
                                    }
                                    break;
                                }
                                case CODE_WEBSERVICES.ESBORRANYSTRAMITS: {    
                                    let numetiquetas = this.webservicesParseVista[i].etiquetas.length;
                                    if(this.webservicesParseVista[i].valores != null){
                                        this.webservicesParseVista[i].valores = this.ordenarPorFecha(this.webservicesParseVista[i].valores, numetiquetas); 
                                    }
                                    
                                    for(let p = 0; p < this.webservicesParse.length; p++){
                                        if(this.webservicesParse[p].code === this.webservicesParseVista[i].code){
                                            this.webservicesParse[p] = _.cloneDeep(this.webservicesParseVista[i]);
                                        }
                                    }
                                    
                                    this.vistaRapidaObj.totEsbor = 0;
                                    if(this.webservicesParseVista[i].valores != null){
                                        this.vistaRapidaObj.totEsbor = this.webservicesParseVista[i].valores.length;
                                    }
                                    break;
                                }
                                case CODE_WEBSERVICES.NOTIFICACIONSBYNIF: {
                                    this.vistaRapidaObj.totNotifi = 0;
                                    if(this.webservicesParseVista[i].valores != null){
                                        this.vistaRapidaObj.totNotifi = this.webservicesParseVista[i].valores.length;
                                    }
                                    break;
                                }
                                case CODE_WEBSERVICES.QUEIXESBYNIF: {
                                    this.vistaRapidaObj.totQuejas = 0;
                                    let numorden : number = 0;
                                    this.webQueixas = new WebservicesParse();
                                    this.arrayVal =  new Array<Array<WebserviceValorDato>>();
                                    this.calculoImportes(this.webservicesParseVista, CODE_WEBSERVICES.QUEIXESBYNIF, i, numorden, numws, ETIQUETAS.NOMBRE.datacreacio);
                                    this.webQueixas = _.cloneDeep(this.webservicesParseVista[i]);
                                    this.webQueixas.valores = _.cloneDeep(this.arrayVal);
                                    if(this.webQueixas.valores != null){
                                        this.vistaRapidaObj.totQuejas = this.webQueixas.valores.length;
                                    }
                                    break;
                                }
                                case CODE_WEBSERVICES.NOTCOMVIGWSI: {
                                    this.vistaRapidaObj.totNotVig = 0;
                                    this.vistaRapidaObj.totComVig = 0;

                                    this.webNotific = new WebservicesParse();
                                    this.webComunic = new WebservicesParse();

                                    this.arrayVal =  new Array<Array<WebserviceValorDato>>();
                                    this.arrayValApoyo =  new Array<Array<WebserviceValorDato>>();

                                    let numorden : number = 0;
                                    this.calculoImportes(this.webservicesParseVista, CODE_WEBSERVICES.NOTCOMVIGWSI, i, numorden, numws, ETIQUETAS.NOMBRE.tipus);
                                    this.webNotific = _.cloneDeep(this.webservicesParseVista[i]);
                                    this.webComunic = _.cloneDeep(this.webservicesParseVista[i]);
                                    this.webNotific.valores = _.cloneDeep(this.arrayVal);
                                    this.webComunic.valores = _.cloneDeep(this.arrayValApoyo);
                                    break;
                                }
                                case CODE_WEBSERVICES.REBUTSULTANYWSI: {
                                    this.vistaRapidaObj.totRebuts = 0;
                                    this.vistaRapidaObj.totImportRebuts = 0;
                                    this.vistaRapidaObj.totRebutPag = 0;
                                    this.vistaRapidaObj.totRebutPenDins = 0;
                                    this.vistaRapidaObj.totRebutPenFora = 0;
                                    this.vistaRapidaObj.totRebutTramtit = 0;
                                    this.vistaRapidaObj.totRebutAnul = 0;
                                    this.vistaRapidaObj.rebutpagat = 0;
                                    this.vistaRapidaObj.reubupendins = 0;
                                    this.vistaRapidaObj.reubupenfora = 0;
                                    this.vistaRapidaObj.tramitantse = 0;
                                    this.vistaRapidaObj.rebutanul = 0;
                                    let numorden : number = 0;
                                    if(this.webservicesParseVista[i].valores != null){
                                        this.vistaRapidaObj.totRebuts = this.webservicesParseVista[i].valores.length;
                                    }
                                    this.calculoImportes(this.webservicesParseVista, CODE_WEBSERVICES.REBUTSULTANYWSI, i, numorden, numws, ETIQUETAS.NOMBRE.recimport);
                                    if(this.vistaRapidaObj.totRebutAnul != 0){
                                        this.vistaRapidaObj.totRebuts = this.vistaRapidaObj.totRebuts - this.vistaRapidaObj.totRebutAnul;
                                    }
                                    if(this.vistaRapidaObj.rebutanul != 0){
                                        this.vistaRapidaObj.totImportRebuts = this.vistaRapidaObj.totImportRebuts - this.vistaRapidaObj.rebutanul;
                                    }
                                    break;
                                }
                                case CODE_WEBSERVICES.PASFACTULTANYWSI: {
                                    this.vistaRapidaObj.totFacturas = 0;
                                    this.vistaRapidaObj.totFacPag = 0;
                                    this.vistaRapidaObj.totFacPend = 0;
                                    this.vistaRapidaObj.totFacIncid = 0;
                                    this.vistaRapidaObj.totImportFact = 0;
                                    this.vistaRapidaObj.factpagat = 0;
                                    this.vistaRapidaObj.factincid = 0;
                                    this.vistaRapidaObj.factpende = 0;
                                    let numorden : number = 0;
                                    if(this.webservicesParseVista[i].valores != null){
                                        this.vistaRapidaObj.totFacturas = this.webservicesParseVista[i].valores.length;
                                    }
                                    this.calculoImportes(this.webservicesParseVista, CODE_WEBSERVICES.PASFACTULTANYWSI, i, numorden, numws, ETIQUETAS.NOMBRE.importtotal);
                                    break;
                                }
                                case CODE_WEBSERVICES.PASEXPEDULTANYWSI: {
                                    this.vistaRapidaObj.totExped = 0;
                                    this.vistaRapidaObj.totExpedAjud = 0;
                                    this.vistaRapidaObj.totExpedTrib = 0;
                                    this.vistaRapidaObj.totExpedSanc = 0;
                                    this.vistaRapidaObj.totExpedAltr = 0;
                                    this.vistaRapidaObj.expedCurso = 0;
                                    this.vistaRapidaObj.expedFinal = 0;
                                    this.vistaRapidaObj.expedAjud = 0;
                                    this.vistaRapidaObj.expedTrib = 0;
                                    this.vistaRapidaObj.expedSanc = 0;
                                    this.vistaRapidaObj.expedAltr = 0;
                                    let numorden : number = 0;
                                    this.calculoImportes(this.webservicesParseVista, CODE_WEBSERVICES.PASEXPEDULTANYWSI, i, numorden, numws, ETIQUETAS.NOMBRE.carpnomestat);
                                    if(this.webservicesParseVista[i].valores != null){
                                        this.vistaRapidaObj.totExped = this.webservicesParseVista[i].valores.length;
                                    }
                                    break;
                                }
                                case CODE_WEBSERVICES.NIOSDISPONIBLESPROV: {
                                    let numorden : number = 0;
                                    this.vistaRapidaObj.totContra = 0;
                                    this.vistaRapidaObj.totImportContr = 0;
                                    this.vistaRapidaObj.contImporFac = 0;
                                    this.vistaRapidaObj.contImporNotFac = 0;
                                    this.calculoImportes(this.webservicesParseVista, CODE_WEBSERVICES.NIOSDISPONIBLESPROV, i, numorden, numws, ETIQUETAS.NOMBRE.importtotal);
                                    if(this.webservicesParseVista[i].valores != null){
                                        this.vistaRapidaObj.totContra = this.webservicesParseVista[i].valores.length;
                                    }
                                    this.vistaRapidaObj.contImporFac = this.vistaRapidaObj.totImportContr - this.vistaRapidaObj.contImporNotFac;
                                    break;
                                }
                                case CODE_WEBSERVICES.DADESCONTACTE: {
                                    let numorden : number = 0;
                                    this.vistaRapidaObj.email = "-";
                                    this.vistaRapidaObj.movil = "-";
                                    this.vistaRapidaObj.telefono = "-";
                                    this.vistaRapidaObj.fax = "-";
                                    this.calculoImportes(this.webservicesParseVista, CODE_WEBSERVICES.DADESCONTACTE, i, numorden, numws, ETIQUETAS.NOMBRE.tipus);
                                    break;
                                }
                                case CODE_WEBSERVICES.VRWSPASHABITADADESWSI: {
                                    let numorden : number = 0;
                                    this.vistaRapidaObj.individual = "";
                                    this.vistaRapidaObj.colectivo = "";
                                    this.vistaRapidaObj.padroenable = true;
                                    this.calculoImportes(this.webservicesParseVista, CODE_WEBSERVICES.VRWSPASHABITADADESWSI, i, numorden, numws, ETIQUETAS.NOMBRE.individual);
                                    this.calculoImportes(this.webservicesParseVista, CODE_WEBSERVICES.VRWSPASHABITADADESWSI, i, numorden, numws, ETIQUETAS.NOMBRE.colectivo);
                                    break;
                                }
                              }
                            }
                        }
                        this.setvaluesBusca = _.cloneDeep(this.setvalues);
                        console.log(this.webservicesParse);
                        this.loadingWS = false;
                    }, error => {
                        console.log("Error: " + error);
                        this.loadingWS = false;
                    });

                    return dataGroup;
                }),
                concatMap((dataGroup) => dataGroup?.valor00),
                mergeMap((item) => this.getWsdef(item)),
                map(variable => variable),
                toArray(),
                tap((variable) => {
                    this.assignWsdefsToSetvalue(variable);
                    this.datagroupAux.listaWsdefs = variable;
                    return this.datagroupAux;
                }))
                .pipe(map(res => this.datagroupAux),
                catchError((error: any) => {
                    console.log(error);
                    throw error;
                }));
        } else {
            this.router.navigate(['/internal/home']);
            return of(null);
        }
    }

    /**
    * Función para calcular los distintos valores de los distintos apartados de la vista rápida
    * @param ws listado de valores que nos traemos de los WS
    * @param code codigo del wdefs
    * @param numWsVr posicion del objeto que nos traemos dentro de la lista de objetos.
    * @param numorden utilizado para localizar el posicionamiento de etiquetas
    * @param numws utilizado para localizar el posicionamiento de los valores.
    * @param etiqueta etiqueta a la que iremos a buscar el valor.
    */
    public calculoImportes(ws: WebservicesParse[], code: string, numWsVr: number, numorden: number, numws: number, etiqueta: string){
        for(let x = 0; x < ws[numWsVr].etiquetas.length; x++){
            /*control posicionamiento etiquetas tramites*/
            if(ws[numWsVr].etiquetas[x].code.trim() === ETIQUETAS.NOMBRE.desctramit){
                this.vistaRapidaObj.posiciodescat = ws[numWsVr].etiquetas[x].numorder;
            }
            if(ws[numWsVr].etiquetas[x].code.trim() === ETIQUETAS.NOMBRE.detTramit){
                this.vistaRapidaObj.posiciodetacat = ws[numWsVr].etiquetas[x].numorder;
            }
            /*control posicionamiento etiquetas otros servicios*/
            if(ws[numWsVr].etiquetas[x].code.trim() === ETIQUETAS.NOMBRE.descripcio){
                this.vistaRapidaObj.posicioaltdescat = ws[numWsVr].etiquetas[x].numorder;
            }
            if(ws[numWsVr].etiquetas[x].code.trim() === ETIQUETAS.NOMBRE.detall){
                this.vistaRapidaObj.posicioaltdetacat = ws[numWsVr].etiquetas[x].numorder;
            }

            /*control posicionamiento etiquetas avisos multiidioma*/
            if(ws[numWsVr].etiquetas[x].code.trim() === ETIQUETAS.NOMBRE.textcarpcat){
                this.vistaRapidaObj.textcarpcat = ws[numWsVr].etiquetas[x].numorder;
            }
            if(ws[numWsVr].etiquetas[x].code.trim() === ETIQUETAS.NOMBRE.textcarpesp){
                this.vistaRapidaObj.textcarpesp = ws[numWsVr].etiquetas[x].numorder;
            }

            if(ws[numWsVr].etiquetas[x].code.trim() === ETIQUETAS.NOMBRE.estat_calcul){
                this.vistaRapidaObj.posiciorebutestat = ws[numWsVr].etiquetas[x].numorder;
            }
            if(ws[numWsVr].etiquetas[x].code.trim() === ETIQUETAS.NOMBRE.estatvrfactura){
                this.vistaRapidaObj.posiciofact = ws[numWsVr].etiquetas[x].numorder;
            }
            if(ws[numWsVr].etiquetas[x].code.trim() === ETIQUETAS.NOMBRE.importepte){
                this.vistaRapidaObj.posiciocontrac = ws[numWsVr].etiquetas[x].numorder;
            }
            if(ws[numWsVr].etiquetas[x].code.trim() === ETIQUETAS.NOMBRE.descripcio){
                this.vistaRapidaObj.posicioDescrip = ws[numWsVr].etiquetas[x].numorder;
            }
            if(ws[numWsVr].etiquetas[x].code.trim() === ETIQUETAS.NOMBRE.datacreacio){
                this.vistaRapidaObj.posiciofecha = ws[numWsVr].etiquetas[x].numorder;
            }
            if(ws[numWsVr].etiquetas[x].code.trim() === ETIQUETAS.NOMBRE.categcodi){
                this.vistaRapidaObj.posicioexped = ws[numWsVr].etiquetas[x].numorder;
            }
        }
        if(ws[numWsVr].valores != null){
            for(let x = 0; x < ws[numWsVr].etiquetas.length; x++){
                if(ws[numWsVr].etiquetas[x].code == etiqueta){
                    numorden = ws[numWsVr].etiquetas[x].numorder;
                    for(let z = 0; z < ws[numws - 1].valores.length; z++){
                        for(let y = 0; y < ws[numws - 1].valores[z].length; y++){
                            if(numorden == ws[numws - 1].valores[z][y].numorder){
                                switch(code) {
                                    case CODE_WEBSERVICES.REBUTSULTANYWSI: {
                                        /** calculo del importe total; de momento dentro de valor etiquetas hasta que se solucione problema*/
                                        this.vistaRapidaObj.totImportRebuts = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.totImportRebuts;
                                        /**calculo del importe por estado del recibo */
                                        for(let t = 0; t < ws[numws - 1].valores[z].length; t++){
                                            if(ws[numws - 1].valores[z][t].numorder === this.vistaRapidaObj.posiciorebutestat){
                                                let estat = ws[numws - 1].valores[z][t].valor;
                                                switch(estat){
                                                    case ETIQUETAS.VALORES.REBUTSESTAT.pe:{
                                                        this.vistaRapidaObj.reubupenfora = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.reubupenfora;
                                                        this.vistaRapidaObj.totRebutPenFora++;
                                                        break;
                                                    }
                                                    case ETIQUETAS.VALORES.REBUTSESTAT.pvdt:{
                                                        this.vistaRapidaObj.reubupendins = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.reubupendins;
                                                        this.vistaRapidaObj.totRebutPenDins++;
                                                        break;
                                                    }
                                                    case ETIQUETAS.VALORES.REBUTSESTAT.c:{
                                                        this.vistaRapidaObj.rebutpagat = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.rebutpagat;
                                                        this.vistaRapidaObj.totRebutPag++;
                                                        break;
                                                    }
                                                    case ETIQUETAS.VALORES.REBUTSESTAT.tr:
                                                    case ETIQUETAS.VALORES.REBUTSESTAT.pvft:
                                                    case ETIQUETAS.VALORES.REBUTSESTAT.pvte:{
                                                        this.vistaRapidaObj.tramitantse = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.tramitantse;
                                                        this.vistaRapidaObj.totRebutTramtit++;
                                                        break;
                                                    }
                                                    case ETIQUETAS.VALORES.REBUTS.a:{
                                                        this.vistaRapidaObj.rebutanul = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.rebutanul;
                                                        this.vistaRapidaObj.totRebutAnul++;
                                                        break;
                                                    }
                                                    default: {
                                                        this.vistaRapidaObj.rebutanul = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.rebutanul;
                                                        this.vistaRapidaObj.totRebutAnul++;
                                                        break; 
                                                    }
                                                }
                                            }
                                        }
                                        break;
                                    }
                                    case CODE_WEBSERVICES.PASFACTULTANYWSI: {
                                        /** calculo del importe total */
                                        this.vistaRapidaObj.totImportFact = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.totImportFact;
                                        /**calculo del importe por estado de la factura */
                                        for(let t = 0; t < ws[numws - 1].valores[z].length; t++){
                                            if(ws[numws - 1].valores[z][t].numorder === this.vistaRapidaObj.posiciofact){
                                                let situacion = ws[numws - 1].valores[z][t].valor;
                                                switch(situacion.trim()){
                                                    case ETIQUETAS.VALORES.FACTURES.pagada:{
                                                        this.vistaRapidaObj.factpagat = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.factpagat;
                                                        this.vistaRapidaObj.totFacPag++;
                                                        break;
                                                    }

                                                    case ETIQUETAS.VALORES.FACTURES.incidencia:
                                                    case ETIQUETAS.VALORES.FACTURES.rebutjada:{
                                                        this.vistaRapidaObj.factincid = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.factincid;
                                                        this.vistaRapidaObj.totFacIncid++;
                                                        break;
                                                    }
                                                    case ETIQUETAS.VALORES.FACTURES.pendent:{
                                                        this.vistaRapidaObj.factpende = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.factpende;
                                                        this.vistaRapidaObj.totFacPend++;
                                                        break;
                                                    }
                                                }
                                            }
                                        }
                                        break;
                                    }
                                    case CODE_WEBSERVICES.QUEIXESBYNIF: {
                                        let fechaAño = new Date().setFullYear(new Date().getFullYear() - 1);
                                        for(let m = 0; m < ws[numws - 1].valores[z].length; m++){
                                            if(ws[numws - 1].valores[z][m].numorder === this.vistaRapidaObj.posiciofecha){
                                                let fechaWSForm = this.formatFecha(ws[numws - 1].valores[z][m].valor);
                                                
                                                let fechames = fechaWSForm.substring(0, 3);
                                                let fechadia = fechaWSForm.substring(3, 6);
                                                let fechaanio = fechaWSForm.substring(6, 10);
                                                let fechtot = fechadia + fechames + fechaanio;

                                                let fechaWSDate = new Date(fechtot);
                                                let fechaWS = fechaWSDate.setFullYear(fechaWSDate.getFullYear());
                                                if(fechaWS >= fechaAño){
                                                    this.arrayVal.push(ws[numws - 1].valores[z]);
                                                }
                                            }
                                        }
                                        break;
                                    }
                                    case CODE_WEBSERVICES.NIOSDISPONIBLESPROV: {
                                        /** calculo del importe total */
                                        this.vistaRapidaObj.totImportContr = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.totImportContr;
                                        /**calculo del importe por estado del contrato */
                                        for(let t = 0; t < ws[numws - 1].valores[z].length; t++){
                                            if(ws[numws - 1].valores[z][t].numorder === this.vistaRapidaObj.posiciocontrac){
                                                this.vistaRapidaObj.contImporNotFac = +ws[numws - 1].valores[z][t].valor + this.vistaRapidaObj.contImporNotFac;
                                            }
                                        }
                                        break;
                                    }
                                    case CODE_WEBSERVICES.PASEXPEDULTANYWSI: {

                                        for(let t = 0; t < ws[numws - 1].valores[z].length; t++){
                                            if(ws[numws - 1].valores[z][t].numorder === this.vistaRapidaObj.posicioexped){
                                                let situacion = ws[numws - 1].valores[z][t].valor;
                                                switch(situacion.trim()){
                                                    case ETIQUETAS.VALORES.EXPEDIENTS.ajud:{
                                                        this.vistaRapidaObj.expedAjud = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.expedAjud;
                                                        this.vistaRapidaObj.totExpedAjud++;
                                                        break;
                                                    }
                                                    case ETIQUETAS.VALORES.EXPEDIENTS.trib:{
                                                        this.vistaRapidaObj.expedTrib = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.expedTrib;
                                                        this.vistaRapidaObj.totExpedTrib++;
                                                        break;
                                                    }
                                                    case ETIQUETAS.VALORES.EXPEDIENTS.satrans:{
                                                        this.vistaRapidaObj.expedSanc = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.expedSanc;
                                                        this.vistaRapidaObj.totExpedSanc++;
                                                        break;
                                                    }
                                                    case ETIQUETAS.VALORES.EXPEDIENTS.altr:{
                                                        this.vistaRapidaObj.expedAltr = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.expedAltr;
                                                        this.vistaRapidaObj.totExpedAltr++;
                                                        break;
                                                    }
                                                }
                                            }
                                        }

                                        let valor = ws[numws - 1].valores[z][y].valor;
                                        switch(valor){
                                            case ETIQUETAS.VALORES.EXPEDIENTS.excucio:
                                            case ETIQUETAS.VALORES.EXPEDIENTS.arxivat:
                                            case ETIQUETAS.VALORES.EXPEDIENTS.tancat:{
                                                this.vistaRapidaObj.expedFinal++;
                                                break;
                                            }
                                            default: {
                                                this.vistaRapidaObj.expedCurso++;
                                                break;
                                            }
                                        }
                                        break;
                                    }
                                    case CODE_WEBSERVICES.NOTCOMVIGWSI: {
                                        if(ws[numws - 1].valores[z][y].valor === ETIQUETAS.VALORES.NOTIFIC.n){
                                            this.existNotif = true;
                                            this.vistaRapidaObj.totNotVig++;
                                            this.arrayVal.push(ws[numws - 1].valores[z]);
                                        }else{
                                            this.existComun = true;
                                            this.vistaRapidaObj.totComVig++;
                                            this.arrayValApoyo.push(ws[numws - 1].valores[z]);
                                        }
                                        break;
                                    }
                                    case CODE_WEBSERVICES.DADESCONTACTE: {
                                        let valor = ws[numws - 1].valores[z][y].valor;
                                        if(valor === ETIQUETAS.VALORES.CONTACTE.movil){
                                            for(let d = 0; d < ws[numws - 1].valores[z].length; d++){
                                                if(ws[numws - 1].valores[z][d].numorder === this.vistaRapidaObj.posicioDescrip){
                                                    this.vistaRapidaObj.movil = ws[numws - 1].valores[z][d].valor;
                                                }
                                            }
                                        }
                                        if(valor === ETIQUETAS.VALORES.CONTACTE.fax){
                                            for(let d = 0; d < ws[numws - 1].valores[z].length; d++){
                                                if(ws[numws - 1].valores[z][d].numorder === this.vistaRapidaObj.posicioDescrip){
                                                    this.vistaRapidaObj.fax = ws[numws - 1].valores[z][d].valor;
                                                }
                                            }
                                        }
                                        if(valor === ETIQUETAS.VALORES.CONTACTE.email){
                                            for(let d = 0; d < ws[numws - 1].valores[z].length; d++){
                                                if(ws[numws - 1].valores[z][d].numorder === this.vistaRapidaObj.posicioDescrip){
                                                    this.vistaRapidaObj.email = ws[numws - 1].valores[z][d].valor;
                                                }
                                            }
                                        }
                                        if(valor === ETIQUETAS.VALORES.CONTACTE.telefono){
                                            for(let d = 0; d < ws[numws - 1].valores[z].length; d++){
                                                if(ws[numws - 1].valores[z][d].numorder === this.vistaRapidaObj.posicioDescrip){
                                                    this.vistaRapidaObj.telefono = ws[numws - 1].valores[z][d].valor;
                                                }
                                            }
                                        }
                                        break;
                                    }
                                    case CODE_WEBSERVICES.WSAVISOSHABITANTEPOB: {
                                        let idioma = localStorage.getItem(LS_LANG) || DEFAULT_LANG;
                                        for(let t = 0; t < ws[numws - 1].etiquetas.length; t++){
                                            if(idioma == OPTIONAL_LANG){
                                                this.gestioEtiquTramitsAtres(ws, numws, t, this.vistaRapidaObj.textcarpcat);
                                                this.gestioValoresTramitsAtres(ws, numws, t, z, this.vistaRapidaObj.textcarpcat);
                                            }else{
                                                this.gestioEtiquTramitsAtres(ws, numws, t, this.vistaRapidaObj.textcarpesp);
                                                this.gestioValoresTramitsAtres(ws, numws, t, z, this.vistaRapidaObj.textcarpesp);
                                            }
                                        }
                                        break;
                                    }

                                    case CODE_WEBSERVICES.VRWSPASHABITADADESWSI: {
                                        let valor = ws[numws - 1].valores[z][y].valor;
                                        if(etiqueta === ETIQUETAS.NOMBRE.individual){
                                            this.vistaRapidaObj.individual = _.cloneDeep(valor);
                                        }
                                        if(etiqueta === ETIQUETAS.NOMBRE.colectivo){
                                            this.vistaRapidaObj.colectivo = _.cloneDeep(valor);
                                        }
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    /**
    * Función para ordenar los objetos de datos esborranys que me vienen del ws ordenados por fecha
    * @param datos array objetos de datos esborranys
    * @param numetiquetas numero de teiquetas que vienen asociados al bobjeto
    */
    public ordenarPorFecha(datos: WebserviceValorDato[][], numetiquetas: number): WebserviceValorDato[][] {

        let formatoFecha = /^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/;
        let fechas: string[] = [];

        for (let i = 0; i < datos.length; i++) {
            for (let x = 0; x < numetiquetas; x++) {
                if (datos[i][x] != null && formatoFecha.test(datos[i][x].valor)) {
                    fechas.push(datos[i][x].valor);
                    break;
                }
            }
        }
        let fechasOrdenadas = this.ordenarFechas(fechas);
        let arrayOrdenado: any[][] = [];
        for (let fecha of fechasOrdenadas) {
            for (let i = 0; i < datos.length; i++) {
                for (let x = 0; x < numetiquetas; x++) {
                    if (datos[i][x] != null && formatoFecha.test(datos[i][x].valor)) {
                        if (datos[i][x].valor === fecha) {
                            arrayOrdenado.push(datos[i]);
                            break;
                        }
                    }
                }
            }
        }

        return arrayOrdenado;
    }

    /**
    * Función para ordenar el array de fechas que me viene del ws
    * @param fechas listado de valores que nos traemos de los WS
    */
    public ordenarFechas(fechas: string[]): string[] {
        function convertirAFecha(cadenaFecha: string): Date {
            let partes = cadenaFecha.split(" ");
            let fechaPartes = partes[0].split("/");
            let horaPartes = partes[1].split(":");
    
            // El mes se resta 1 porque en JavaScript los meses van de 0 a 11
            return new Date(Number(fechaPartes[2]), Number(fechaPartes[1]) - 1, Number(fechaPartes[0]), Number(horaPartes[0]), Number(horaPartes[1]), Number(horaPartes[2]));
        }
    
        return fechas.sort(function(a, b) {
            // Invertir el orden de la comparación para ordenar de manera inversa
            return convertirAFecha(b).getTime() - convertirAFecha(a).getTime();
        });
    }

    /**
    * Función para gestionar tramits y altres serveis quitando etiquetas que correspondan
    * @param ws listado de info traida de los WS
    * @param posws posicion del ws en la lista.
    * @param posetiq posicion de etiqueta en la lista de etiquetas
    * @param etiqueta posicion de etiqueta que vamos a suprimir.
    */
    gestioEtiquTramitsAtres(ws: WebservicesParse[], posws: number, posetiq: number, etiqueta: number){
        if(ws[posws - 1].etiquetas[posetiq].numorder === etiqueta){
            const index = ws[posws - 1].etiquetas.indexOf(ws[posws - 1].etiquetas[posetiq], 0);
            if (index > -1) {
                ws[posws - 1].etiquetas.splice(index, 1);
            }
        }
    }

    /**
    * Función para gestionar tramits y altres serveis quitando los valorese relacionados que correspondan
    * @param ws listado de info traida de los WS
    * @param posws posicion del ws en la lista.
    * @param posetiq posicion de etiqueta en la lista de etiquetas
    * @param posval posicion del valor en la lista de valores
    * @param etiqueta posicion del valor que vamos a suprimir.
    */
    gestioValoresTramitsAtres(ws: WebservicesParse[], posws: number, posetiq: number, posval: number, etiqueta: number){
        if(ws[posws - 1].valores[posval][posetiq].numorder === etiqueta){
            const index = ws[posws - 1].valores[posval].indexOf(ws[posws - 1].valores[posval][posetiq], 0);
            if (index > -1) {
                ws[posws - 1].valores[posval].splice(index, 1);
            }
        }
    }

    /**
    * Solicita los wsdefs de cada setvalue
    * @param item Setvalue
    */
    getWsdef(item: any) {
        let setvalue = new Setvalues();
        let wsdefact = new Array<Wsdefs>();
        setvalue = item;
        for(let i = 0; i < this.wsdefsrol.length; i++){
            if(setvalue.id === this.wsdefsrol[i].setvalue.id){
                wsdefact.push(this.wsdefsrol[i]);
            }
        }
        return of(wsdefact);
    }

    /**
    * Asigna a cada setvalue su array de wsdefs
    * @param items Lista de listas de wsdefs de un setvalue
    */
    assignWsdefsToSetvalue(items: any) {
        for (let i = 0; i < items.length; i++) {
            const array = items[i];
            if (array.length > 0) {
                const setvalue_id = array[0].setvalue.id;
                for (let j = 0; j < this.setvalues.length; j++) {
                    const setvalue = this.setvalues[j];
                    if (setvalue.id == setvalue_id) {
                        setvalue.wsdefs = _.cloneDeep(array);
                        setvalue.wsdefs = _.orderBy(setvalue.wsdefs, 'numorder');
                        break;
                    }
                }
            }
        }
    }

    /**
    * @description
    * Gestión de los Webservices que están desactivados
    * @param dato WS que nos traemos del cliente
    */
    public recogerWS(dato: Wsdefs, posicionA: number, posicionB: number) {

        this.gestionLabelStyle();
        if(this.vista_rapida.quickview == 1){
            const el = document.getElementById("vistaRapida");
            if (el) {
                el.classList.remove('active');
            }
        }

        if(posicionA != null && posicionB != null){
            const el = document.getElementById("labelWS" + posicionA + posicionB);
            if (el) {
                el.classList.add('active');
            }
        }

        this.vistaRapida = false;
        this.isTramite = false;
        let chivato = false;
        //this.webservicesParseDef = new Array<WebservicesParse>();

        for(let i = 0; i < this.webservicesParse.length; i++){
            if(this.webservicesParse[i].code == dato.code){
                chivato = true;
            }
        }

        if(chivato == false){
            return this.recogerWSObservable(dato);
        }else{
            return of(this.recogerWSEnable(dato, posicionA, posicionB));
        }

    }

    /**
    * @description
    * Hacemos la llamada al servidor de los Webservices que están desactivados
    * @param dato WS que nos traemos del cliente
    */
    public recogerWSObservable(dato: Wsdefs) : Observable<any> {
        /*Rellenamos el objeto webservice para pasarselo al servidor*/
        let webser = this.asignacionAtribObject(dato);
        return this.repositoryService.doPost(PETICIONES.webservice.doPost, webser).pipe(map(data => {

            let webservice = new Array<WebservicesParse>();
            webservice = _.cloneDeep(data);

            /**Formateamos las URLS para que esten disponibles en una segunda llamada (no carga el WS)*/
            this.formatTipoWS(webservice);
            this.webservicesParse.push(webservice[0]);

            this.webservicesParseDef = data;
            this.formatTipoWS(this.webservicesParseDef);
            this.asignacionFormatoValor(this.webservicesParseDef[0]);

            if(this.webservicesParseDef[0].valores != null){
                this.filtroFechaNumero(this.webservicesParseDef[0]);
            }

            /*CalculoImportes para gestionar tramits y altres serveis quitando etiquetas y valores cuando corresponda*/
            switch(this.webservicesParseDef[0].code){
                case CODE_WEBSERVICES.WSAVISOSHABITANTEPOB:{
                    this.calculoImportes(this.webservicesParseDef, this.webservicesParseDef[0].code, 0, 0, 1, ETIQUETAS.NOMBRE.textcarpcat);
                    this.calculoImportes(this.webservicesParseDef, this.webservicesParseDef[0].code, 0, 0, 1, ETIQUETAS.NOMBRE.textcarpesp);
                    break;
                }
            }

            this.gestionIconos(this.webservicesParseDef[0]);
            this.webserviceVista = _.cloneDeep(this.webservicesParseDef[0]);
            return this.webservicesParseDef;
        }, (error: any)=> {
            this.textContacte = true;
            console.log("Error: " + error);
        }));
    }

    /**
    * @description
    * Gestión de los Webservices que están activados
    * @param dato WS que nos traemos del cliente
    * @param posicionA Posicion que ocupa el setvalue seleccionado
    * @param posicionB Posicion que ocupa el ws seleccionado
    */
    public recogerWSEnable(dato: Wsdefs, posicionA: number, posicionB: number): Observable<any> {

        this.gestionLabelStyle();
        if(this.vista_rapida.quickview == 1){
            const el = document.getElementById("vistaRapida");
            if (el) {
                el.classList.remove('active');
            }
        }

        if(posicionA != null && posicionB != null){
            const el2 = document.getElementById("labelWS" + posicionA + posicionB);
            if (el2) {
                el2.classList.add('active');
            }
        }

        this.vistaRapida = false;
        this.isTramite = false;
        this.webservicesParseDef = new Array<WebservicesParse>();

        if(this.wsenabledrefresh){
            let webser =  this.asignacionAtribObject(dato);
            return this.repositoryService.doPost(PETICIONES.webservice.doPost, webser).pipe(map(data => {
                let ws = Array<WebservicesParse>();
                ws = _.cloneDeep(data);
                if (this.webservicesParse != null) {
                    for (let i = 0; i < this.webservicesParse.length; i++) {
                        if (this.webservicesParse[i].code === dato.code) {
                            console.log(this.webservicesParse[i]);
                            this.webservicesParseDef.push(ws[0]);
                        }
                    }
                }

                this.ordenarVistaWS();
                this.asignacionFormatoValor(this.webservicesParseDef[0]);
                this.gestionIconos(this.webservicesParseDef[0]);
                this.webserviceVista = _.cloneDeep(this.webservicesParseDef[0]);
                this.wsenabledrefresh = false;
                return this.webserviceVista;

            }, (error: any)=> {
                this.textContacte = true;
                console.log("Error: " + error);
            }));
        }else{
            let chivato : boolean = false;
            if (this.webservicesParse != null) {
                for (let i = 0; i < this.webservicesParse.length; i++) {
                    if (this.webservicesParse[i].code === dato.code) {
                        console.log(this.webservicesParse[i]);
                        this.webservicesParseDef.push(this.webservicesParse[i]);
                        chivato = true;
                    }
                }
                if(!chivato){
                    let webser = this.asignacionAtribObject(dato);
                    return this.repositoryService.doPost(PETICIONES.webservice.doPost, webser).pipe(map(data => {    
                        let ws = Array<WebservicesParse>();
                        ws = _.cloneDeep(data);
                        this.webservicesParseDef.push(ws[0]);
                        this.ordenarVistaWS();
                        this.asignacionFormatoValor(this.webservicesParseDef[0]);
                        this.gestionIconos(this.webservicesParseDef[0]);
                        this.webserviceVista = _.cloneDeep(this.webservicesParseDef[0]);
                        return this.webserviceVista;
                    }, (error: any) => {
                        console.log("Error: " + error);
                    }));
                }else{
                    this.ordenarVistaWS();
                    this.asignacionFormatoValor(this.webservicesParseDef[0]);
                    this.gestionIconos(this.webservicesParseDef[0]);
                    this.webserviceVista = _.cloneDeep(this.webservicesParseDef[0]);
                    return of(this.webserviceVista);
                }
            }
        }
        return of(null); 
    }

    /**
    * @description
    * Etiquetas y valores se desordenan despues del refresh; así que las volvemos a ordenar
    */
    public ordenarVistaWS(){
        if (this.webservicesParseDef[0].etiquetas != null) {
            if (this.webservicesParseDef[0].etiquetas.length > 0 && this.webservicesParseDef[0].valores != null) {
                this.webservicesParseDef[0].etiquetas = _.orderBy(this.webservicesParseDef[0].etiquetas, 'numorder');
                for (let i = 0; i < this.webservicesParseDef[0].valores.length; i++) {
                    this.webservicesParseDef[0].valores[i] = _.orderBy(this.webservicesParseDef[0].valores[i], 'numorder');
                }

                if (this.webservicesParseDef[0].valores != null) {
                    this.filtroFechaNumero(this.webservicesParseDef[0]);
                }
            }
        }
    }


    /**
    * @description
    * Desactiva el estilo activo de todos las pestañas de los web_services
    */
    public gestionLabelStyle(){
        var array = document.getElementsByClassName("text__sm");
        for(var e = 0; e < array.length; e++) {
            var elemento = array[e];
            if(elemento.className === "text__sm clickable active"){
                elemento.className = "text__sm clickable";
            }
        }
    }

    /**
    * @description
    * Activa el estilo activo de todos vista rapida; desaciva los demás y oculta los WS
    * seleccionados mostrando la vista rápida
    */
    public vistaRapidaEvent(){

        let menuAbrir = document.getElementById("collapseOne");
        let menuCerrar = document.getElementById("menumovilCerrar");

        if (menuAbrir && menuCerrar) {
            if(window.screen.width < 500){
                menuAbrir.style.display = "none";
                menuCerrar.style.display = "block";
                window.scrollTo(0, 0);
            }else{
                menuAbrir.style.display = "";
                menuCerrar.style.display = "";
                window.scrollTo(0, 0);
            }
        }

        this.vistaRapida = true;
        this.isTramite = false;
        this.gestionLabelStyle();
        if(this.vista_rapida.quickview == 1){
            const el = document.getElementById("vistaRapida");
            if (el) {
                el.classList.add('active');
            }
        }
    }

    /**
    * @description
    * Formatea el tipo de dato que se visualizan en la tablas de la interfaz (sobretodo enlaces)
    * @param item lista de WS que nos traemos del servidor
    */
    public formatTipoWS(item: WebservicesParse[]) {
        let numero: number = 0;
        for (let i = 0; i < item.length; i++) {
            numero = 0;

            item[i].etiquetas = _.orderBy(item[i].etiquetas, 'numorder');
            if(item[i].valores != null){
                for(let x = 0; x < item[i].valores.length; x++){
                    item[i].valores[x] = _.orderBy(item[i].valores[x], 'numorder');
                }
            }

            if (item[i].etiquetas != null) {
                for (let x = 0; x < item[i].etiquetas.length; x++) {
                    numero++;
                    if(item[i].etiquetas[x].fieldtypeId.format === 1 || item[i].etiquetas[x].fieldtypeId.format === 2){
                        this.valoresLinks(item, i, numero);
                    }
                }
            }
        }
        return item;
    }

    /**
    * @description
    * funcion que construye la url de los links de la s tablas de los WS
    * @param valores array de los datos del ws seleccionado
    * @param posval posicion del WS en la lista de WS almacenados en memoria
    * @param posnum posicion de la etiqueta a la que hace referencia el link
    */
    private valoresLinks(valores: WebservicesParse[], posval: number, posnum: number){
        let url: string = "";
        let codeUrl: string = "";
        let urlCompleta: string = "";
        let idxmldef: number | null = null;

        for(let k = 0; k < this.xmldefs.length; k++){
            if(this.xmldefs[k].code === valores[posval].codXmldef){
                idxmldef = _.cloneDeep(this.xmldefs[k].id);
            }
        }

        for(let p = 0; p < this.fieldLinks.length; p++){
            if(this.fieldLinks[p].xmlfields.length > 0){
                for(let c = 0; c < this.fieldLinks[p].xmlfields.length; c++){
                    if(this.fieldLinks[p].xmlfields[c].xmldefId === idxmldef){
                        if(this.fieldLinks[p].xmlfields[c].code === valores[posval].etiquetas[posnum - 1].code){
                            url = _.cloneDeep(this.fieldLinks[p].url);
                        }
                    }
                }
            }
        }

        if(url.includes('{{FI4_IDNUMBER}}')){
            url = url.replace('{{FI4_IDNUMBER}}', this.nif.toLocaleUpperCase());
        }
        if(url.includes('{{IDIOMA}}')){
            url = url.replace('{{IDIOMA}}', this.idioma);
          }
        /*if(url.includes('{{FI4TOKEN}}')){
            url = url.replace('{{FI4TOKEN}}', this.parameters_code.value);
        }*/
        if (valores[posval].valores != null) {
            for (let y = 0; y < valores[posval].valores.length; y++) {
                codeUrl = valores[posval].valores[y][posnum - 1].valor;
                urlCompleta = url.replace('{{SELF.VALUE}}', codeUrl);
                valores[posval].valores[y][posnum - 1].valor = urlCompleta;
            }
        }
    }

    /**
    * @description
    * Filtro para la busqueda en la tabla de los ws
    * @param text texto que introducimos en la caja de texto
    */
    public filterGlobal(text: string){
        text != null && text != undefined ? _.deburr(_.trim(text).toLocaleLowerCase()) : "";

        if (text == "") {
            this.webserviceVista.valores = _.cloneDeep(this.webservicesParseDef[0].valores);
            return;
        }

        text = Utils.replaceAccentedVowels(text);

        let originalWS = _.cloneDeep(this.webservicesParseDef[0]);
        this.webserviceVista.valores = [];

        for (let i = 0; i < originalWS.valores.length; i++) {
            let match = false;
            let ws = originalWS.valores[i];

            for(let x = 0; x < ws.length; x++) {
                if(ws[x].formato == 0){
                    let registro = _.deburr(_.trim(ws[x].valor).toLocaleLowerCase());
                    if (text != "" && _.includes(registro, text.toLocaleLowerCase())) {
                        match = true;
                        break;
                    }
                }
            }

            if(match) {
                this.webserviceVista.valores.push(ws);
            }
        }
    }

    /**
    * @description
    * Filtro para la busqueda de una categoría o wsdef en el menu selector
    * @param text texto que introducimos en la caja de texto
    */
    public filterMenu(text: string){

        text != null && text != undefined ? _.deburr(_.trim(text).toLocaleLowerCase()) : "";
        text = _.deburr(_.trim(text));

        if (text == "") {
            this.setvalues = _.cloneDeep(this.setvaluesBusca);
            return;
        }

        let originalWS = _.cloneDeep(this.setvaluesBusca);

        this.setvalues = new Array<Setvalues>();
        let setvaluesaux = new Array<Setvalues>();

        let idioma = localStorage.getItem(LS_LANG) || DEFAULT_LANG;

        for (let i = 0; i < originalWS.length; i++) {
            let registro : String = "";
            let match = false;
            let setVal = originalWS[i];

            let setaux = new Setvalues();
            setaux = _.cloneDeep(setVal);
            setaux.wsdefs = new Array<Wsdefs>();

            for(let x = 0; x < setVal.wsdefs.length; x++) {
                if(idioma == "ca"){
                    registro = _.deburr(_.trim(setVal.wsdefs[x].cat).toLocaleLowerCase());
                }else{
                    registro = _.deburr(_.trim(setVal.wsdefs[x].esp).toLocaleLowerCase());
                }
                if (text != "" && _.includes(registro, text.toLocaleLowerCase())) {
                    setaux.wsdefs.push(setVal.wsdefs[x]);
                }
            }

            if(setaux.wsdefs.length > 0){
                setvaluesaux.push(setaux);
            }
        }

        for (let i = 0; i < originalWS.length; i++) {
            let registro : string = "";
            if(idioma == "ca"){
                registro = _.deburr(_.trim(originalWS[i].cat).toLocaleLowerCase());
            }else{
                registro = _.deburr(_.trim(originalWS[i].esp).toLocaleLowerCase());
            }
            if (text != "" && _.includes(registro, text.toLocaleLowerCase())) {
                if(idioma == "ca"){
                    if(_.deburr(_.trim(originalWS[i].cat).toLocaleLowerCase()) == registro){
                        for (let p = 0; p < originalWS.length; p++) {
                            if(_.deburr(_.trim(originalWS[p].cat).toLocaleLowerCase()) == registro){
                                let auxiliar : boolean = false;
                                for(let b = 0; b < setvaluesaux.length; b++){
                                    if(setvaluesaux[b].id === originalWS[i].id){
                                        auxiliar = true;
                                    }
                                }
                                if(auxiliar == false){
                                    setvaluesaux.push(originalWS[p]);
                                }
                                //setvaluesaux.push(originalWS[p]);
                            }
                        }
                    }
                }else{
                    if(_.deburr(_.trim(originalWS[i].esp).toLocaleLowerCase()) == registro){
                        for (let p = 0; p < originalWS.length; p++) {
                            if(_.deburr(_.trim(originalWS[p].esp).toLocaleLowerCase()) == registro){
                                let auxiliar : boolean = false;
                                for(let b = 0; b < setvaluesaux.length; b++){
                                    if(setvaluesaux[b].id === originalWS[i].id){
                                        auxiliar = true;
                                    }
                                }
                                if(auxiliar == false){
                                    setvaluesaux.push(originalWS[p]);
                                }
                                //setvaluesaux.push(originalWS[p]);
                            }
                        }
                    }
                }
            }
        }

        var lookupObject: { [key: string]: Setvalues } = {};
        for(var i in setvaluesaux) {
            lookupObject[setvaluesaux[i].id] = setvaluesaux[i];
         }
    
        for(i in lookupObject) {
            this.setvalues.push(lookupObject[i]);
        }

        this.setvalues = _.orderBy(this.setvalues, 'numorder');
    }

    /**
    * @description
    * Formato de los datos tipo fecha
    * @param tipus fecha como string
    */
    public formatFecha(tipus: string): string {
        if (tipus != null) {
            let cadena = tipus.indexOf('+');
            let fechFortat = tipus.substring(0, cadena);
            let fecha = this.datePipe.transform(fechFortat, 'dd/MM/yyyy');
            return fecha ?? '';
        }else{
            return tipus;
        }
    }

    /**
    * @description
    * Formato de los datos tipo fecha y tipo número
    * @param webservice Webservices que queremos formatear
    */
    public filtroFechaNumero(webservice : WebservicesParse) {
        for(let i = 0; i < webservice.valores.length; i++){
            for(let x = 0; x < webservice.etiquetas.length; x++){
                if (webservice.valores[i][x].valor != null) {
                    if(webservice.etiquetas[x].fieldtypeId.typefld === 1){
                        let valor : string = webservice.valores[i][x].valor.replace('€', '').trim();
                        let decimal: number = +valor;
                        let decimalParse = decimal.toFixed(2);
                        webservice.valores[i][x].valor = decimalParse;
                    }
                    if(webservice.etiquetas[x].fieldtypeId.typefld === 2){
                        let cadena = webservice.valores[i][x].valor.indexOf('+');
                        if(cadena != -1){
                            let fechFortat = webservice.valores[i][x].valor.substring(0, cadena);
                            let fecha = this.datePipe.transform(fechFortat, 'dd/MM/yyyy');
                            webservice.valores[i][x].valor = fecha;
                        }else{
                            let guion = /\-/gi;
                            let fecha = webservice.valores[i][x].valor.replace(guion, '/');
                            webservice.valores[i][x].valor = fecha;
                        }
                    }
                    if(webservice.etiquetas[x].fieldtypeId.typefld === 3){
                        let cadena = webservice.valores[i][x].valor.indexOf('+');
                        if(cadena != -1){
                            let fechFortat = webservice.valores[i][x].valor.substring(0, cadena);
                            let fecha = this.datePipe.transform(fechFortat, 'dd/MM/yyyy h:mm a');
                            webservice.valores[i][x].valor = fecha;
                        }else{
                            let guion = /\-/gi;
                            let fecha = webservice.valores[i][x].valor.replace(guion, '/');
                            webservice.valores[i][x].valor = fecha;
                        }
                    }
                    if(webservice.etiquetas[x].fieldtypeId.code === TIPO_DATO.FI4IMPORT){
                        if(this.idioma === DEFAULT_LANG){
                            webservice.valores[i][x].valor = _.cloneDeep( webservice.etiquetas[x].fieldtypeId.formatout.replace('%s', webservice.valores[i][x].valor));
                        }else{
                            webservice.valores[i][x].valor = _.cloneDeep( webservice.etiquetas[x].fieldtypeId.formatoutes.replace('%s', webservice.valores[i][x].valor));
                        }
                    }
                    if(webservice.etiquetas[x].fieldtypeId.code === TIPO_DATO.FI4PERCENT){
                        if(this.idioma === DEFAULT_LANG){
                            webservice.valores[i][x].valor = _.cloneDeep( webservice.etiquetas[x].fieldtypeId.formatout.replace('%s', webservice.valores[i][x].valor));
                        }else{
                            webservice.valores[i][x].valor = _.cloneDeep( webservice.etiquetas[x].fieldtypeId.formatoutes.replace('%s', webservice.valores[i][x].valor));
                        }
                    }
                }else{
                    webservice.valores[i][x].valor;
                }
            }
        }
    }

    /**
    * @description
    * Ordenación de las columnas de las tablas de los ws
    * @param text code de la etiqueta para identificar la columna que hemos pulsado a ordenar
    * @param numero botón al que pulsamos (1 - orden ascendente; 2 - orden descendente)
    */
    public ordenarColumnas(text: any, numero: number, posicion: number){
        let numOrd : number | null = null
        let arrayDatos = new  Array<WebserviceValorDato>();
        let arrayValores = new Array<Array<WebserviceValorDato>>();
        let esValorString = true;

        for(let i = 0; i < this.webserviceVista.etiquetas.length; i++){
            if(this.webserviceVista.etiquetas[i].code === text){
                numOrd = this.webserviceVista.etiquetas[i].numorder;
            }
        }

        /*Alteramos la vaiable esValorString dependiendo si los valoes son numéricos o no.
        conque haya uno solo que no sea numérico, los trataremos como strings */
        for(let i = 0; i < this.webserviceVista.valores.length; i++){
            for(let x = 0; x < this.webserviceVista.etiquetas.length; x++){
                const item = this.webserviceVista.valores[i][x];
                if (item?.numorder == numOrd) {
                    const valor = String(item.valor);
                    if (!this.isNumeric(valor)) {
                        esValorString = false;
                    }
                }
            }
        }

        /*Añadimos los datos a un Array para posteriormente ordenarlos*/
        for(let i = 0; i < this.webserviceVista.valores.length; i++){
            for(let x = 0; x < this.webserviceVista.etiquetas.length; x++){
                if(this.webserviceVista.valores[i][x].numorder == numOrd){
                    if(esValorString){
                        this.webserviceVista.valores[i][x].valor = +this.webserviceVista.valores[i][x].valor;
                    }
                    arrayDatos.push(this.webserviceVista.valores[i][x]);
                }
            }
        }

        /*Ordenación de manera ascendente*/
        arrayDatos =  _.orderBy(arrayDatos, 'valor');

        /*Al pulsar el boton de nuevo; la ordenación es descendente*/
        if(numero == 2){
            this.butonOrderColUp = true;
            this.butonOrderColDown = false;
            let arrayaux = Array<WebserviceValorDato>();
            arrayaux = arrayDatos;
            arrayDatos = Array<WebserviceValorDato>();
            for(let i = arrayaux.length - 1; i >= 0; i--){
                arrayDatos.push(arrayaux[i]);
            }
        }else{
            this.butonOrderColUp = false;
            this.butonOrderColDown = true;
        }

        /*Volvemos a componer el objeto webservicesParseDef con la ordenación ya realizada*/
        for(let i = 0; i < arrayDatos.length; i++){
            for(let z = 0; z < this.webserviceVista.valores.length; z++){
                for(let x = 0; x < this.webserviceVista.etiquetas.length; x++){
                    if(arrayDatos[i] == this.webserviceVista.valores[z][x]){
                        arrayValores.push(this.webserviceVista.valores[z]);
                    }
                }
            }
        }

        this.webserviceVista.valores = _.cloneDeep(arrayValores);
    }

    /**
    * @description
    * Añadimos al objeto WebservicesParse un atributo que nos dirá el formato con el cual irán los distintos valores
    * @param webservice entidad ws WebservicesParse
    */
    public asignacionFormatoValor (webservice : WebservicesParse) {
        if(webservice != null && webservice.valores != null){
            for(let i = 0; i < webservice.valores.length; i++){
                for(let x = 0; x < webservice.etiquetas.length; x++){
                    webservice.valores[i][x].formato = webservice.etiquetas[x].fieldtypeId.format;
                }
            }
        }
    }

    /**
    * @description
    * Asignamos valores al objeto Webservice que utilizaremos para hacer las llamadas de los WS
    * @param dato WS al cual vamos a hacer la petición
    */
    public asignacionAtribObject(dato: Wsdefs):Webservice{
        let ws = new Webservice();

        ws.tokenacces = this.accesToken;
        ws.userId = this.user;
        ws.nifcif = this.nif.toLocaleUpperCase();
        ws.dboid = this.dboid;
        ws.idioma = localStorage.getItem(LS_LANG) || DEFAULT_LANG;
        ws.codEmpresa = this.idempresa;
        ws.token = this.webservice.token;
        ws.wsdefs[0] = dato;
        ws.permisos = this.permissions;
        ws.rol = this.rol;
        return ws;
    }

    /**
    * @description
    * Asignamos valores al objeto Webservice que utilizaremos para hacer las llamadas de los WS
    * @param dato array de WS al cual vamos a hacer la petición
    */
    public asignacionAtribArrayObject(dato: Wsdefs[]):Webservice{
        let ws = new Webservice();

        ws.tokenacces = this.accesToken;
        ws.userId = this.user;
        ws.nifcif = this.nif.toLocaleUpperCase();
        ws.dboid = this.dboid;
        ws.idioma = localStorage.getItem(LS_LANG) || DEFAULT_LANG;
        ws.codEmpresa = this.idempresa;
        ws.token = this.webservice.token;
        ws.wsdefs = dato;
        ws.permisos = this.permissions;
        ws.rol = this.rol;
        return ws;
    }

    /**
    * @description
    * Nos dice si existe un WS con el codigo pasado por parametro
    * @param code code del WS.
    */
    public buscarObjetoWS(code : string):Boolean{
        let auxiliar = true;
        //wsvistaprevia es la lista de WS filtrados por rol
        for(let i = 0; i < this.wsvistaprevia.length; i++){
            if(this.wsvistaprevia[i].code == code){
                auxiliar = false;
                return auxiliar;
            }
        }
        return auxiliar;
    }

    /**
    * @description
    * Nos devuelve los el array de valores de las notif/comunic para meterlos en el carrusel
    */
    public valoresNotificaciones(): any {
        return this.webNotific.valores != null && this.webNotific.valores.length > 0 ? this.webNotific.valores : null;
    }
    public valoresComunicaciones(): any {
        return this.webComunic.valores != null && this.webComunic.valores.length > 0 ? this.webComunic.valores : null;
    }

    /**
    * @description
    * Mostrar notif/comunic en la vista rápida
    * @param valores Array de datos donde están los datos de las notif/comunic
    * @param numero Diferencia a la función del template y determina que nos traemos
    */
    public recogerValorNotificaciones(valor: any, numero: number) : any {
        let etiquetas = new Array<Xmlfields>();
        for(let i = 0; i < this.webservicesParseVista.length; i++){
            const element = this.webservicesParseVista[i];
            if(element.code == CODE_WEBSERVICES.NOTCOMVIGWSI) {
                etiquetas = _.cloneDeep(element.etiquetas);
            }
        }
        for(let i = 0; i < etiquetas.length; i++){
            for(let x = 0; x < valor.length; x++){
                if(etiquetas[i].code == ETIQUETAS.NOMBRE.tipus && numero == 5){
                    if(etiquetas[i].numorder == valor[x].numorder){
                        return valor[x].valor;
                    }
                }
                if(etiquetas[i].code == ETIQUETAS.NOMBRE.datacreacio && numero == 1){
                    if(etiquetas[i].numorder == valor[x].numorder){
                        return this.formatFecha(valor[x].valor);
                    }
                }
                if(etiquetas[i].code == ETIQUETAS.NOMBRE.titol && numero == 2){
                    if(etiquetas[i].numorder == valor[x].numorder){
                        return valor[x].valor;
                    }
                }
                if(etiquetas[i].code == ETIQUETAS.NOMBRE.tipus && numero == 3){
                    if(etiquetas[i].numorder == valor[x].numorder){
                        return valor[x].valor;
                    }
                }
                if(etiquetas[i].code == ETIQUETAS.NOMBRE.estat && numero == 4){
                    if(etiquetas[i].numorder == valor[x].numorder){
                        return valor[x].valor;
                    }
                }
            }
        }
    }


    /**
    * @description
    * Nos devuelve los el array de valores de las queixas para meterlos en el carrusel
    */
    public valoresQueixas(): any {
        return this.webQueixas.valores != null && this.webQueixas.valores.length > 0 ? this.webQueixas.valores : null;
    }
    
    /**
    * @description
    * Mostrar Queixas en la vista rápida
    * @param valores Array de datos donde están los datos de las queixas
    * @param numero Diferencia a la función del template y determina que nos traemos
    */
    public recogerValorQuejas(valor: any, numero: number) : any {
        let etiquetas = new Array<Xmlfields>();
        for(let i = 0; i < this.webservicesParseVista.length; i++){
            const element = this.webservicesParseVista[i];
            if(element.code == CODE_WEBSERVICES.QUEIXESBYNIF) {
                etiquetas = _.cloneDeep(element.etiquetas);
            }
        }
        for(let i = 0; i < etiquetas.length; i++){
            for(let x = 0; x < valor.length; x++){
                if(etiquetas[i].code == ETIQUETAS.NOMBRE.datacreacio && numero == 1){
                    if(etiquetas[i].numorder == valor[x].numorder){
                        return this.formatFecha(valor[x].valor);
                    }
                }
                if(etiquetas[i].code == ETIQUETAS.NOMBRE.desccurta && numero == 2){
                    if(etiquetas[i].numorder == valor[x].numorder){
                        return valor[x].valor;
                    }
                }
                if(etiquetas[i].code == ETIQUETAS.NOMBRE.estat && numero == 3){
                    if(etiquetas[i].numorder == valor[x].numorder){
                        return valor[x].valor;
                    }
                }
            }
        }
    }

    
    /**
    * @description
    * Nos devuelve el array de valores de los ws empadronamiento para meterlos en el carrusel
    */
    public valoresEmpadronamiento(): any {
        for (let index = 0; index < this.webservicesParseVista.length; index++) {
            const element = this.webservicesParseVista[index];
            if (element.code == CODE_WEBSERVICES.VRWSPASHABITADADESWSI) {
                return element.valores != null && element.valores.length > 0 ? element.valores : null;
            }
        }
        return null;
    }

    /**
    * @description
    * Pasamos el dato específico de los datos empadronamiento en el carrusel
    * @param valores Array de datos donde están los datos de empadronamiento
    * @param numero Diferencia a la función del template y determina que nos traemos.
    */
    public recogerEmpadronamiento(valor: any, numero: number) : any {
        let etiquetas = new Array<Xmlfields>();
        for(let i = 0; i < this.webservicesParseVista.length; i++){
            const element = this.webservicesParseVista[i];
            if(element.code == CODE_WEBSERVICES.VRWSPASHABITADADESWSI) {
                etiquetas = _.cloneDeep(element.etiquetas);
            }
        }
        for(let i = 0; i < etiquetas.length; i++){
            for(let x = 0; x < valor.length; x++){
                if(etiquetas[i].code == ETIQUETAS.NOMBRE.individual && numero == 1){
                    if(etiquetas[i].numorder == valor[x].numorder){
                        return valor[x].valor;
                    }
                }
                if(etiquetas[i].code == ETIQUETAS.NOMBRE.colectivo && numero == 2){
                    if(etiquetas[i].numorder == valor[x].numorder){
                        return valor[x].valor;
                    }
                }
            }
        }
    }

    /**
    * @description
    * Nos devuelve los el array de valores de los borradores para meterlos en el carrusel
    */
    public valoresEsborranys(): any {
        for (let index = 0; index < this.webservicesParseVista.length; index++) {
            const element = this.webservicesParseVista[index];
            if (element.code == CODE_WEBSERVICES.ESBORRANYSTRAMITS) {  
                return element.valores != null && element.valores.length > 0 ? element.valores : null;
            }
        }
        return null;
    }

    /**
    * @description
    * Pasamos el dato específico de los esborranys en el carrusel
    * @param valores Array de datos donde están los datos de los esborranys
    * @param numero Diferencia a la función del template y determina que nos traemos.
    */
    public recogerValoresEsborranys(valor: any, numero: number) : any {
        let etiquetas = new Array<Xmlfields>();
        for(let i = 0; i < this.webservicesParseVista.length; i++){
            const element = this.webservicesParseVista[i];
            if (element.code == CODE_WEBSERVICES.ESBORRANYSTRAMITS) {  
                etiquetas = _.cloneDeep(element.etiquetas);
            }
        }
        for(let i = 0; i < etiquetas.length; i++){
            for(let x = 0; x < valor.length; x++){
                if(etiquetas[i].code == ETIQUETAS.NOMBRE.nomesborrany && numero == 1){
                    if(etiquetas[i].numorder == valor[x].numorder){
                        return valor[x].valor;
                    }
                }
                if(etiquetas[i].code == ETIQUETAS.NOMBRE.paramslinkesbregtel && numero == 2){
                    if(etiquetas[i].numorder == valor[x].numorder){
                        return valor[x].valor;
                    }
                }
                if(etiquetas[i].code == ETIQUETAS.NOMBRE.descesborrany && numero == 3){
                    if(etiquetas[i].numorder == valor[x].numorder){
                        return valor[x].valor;
                    }
                }
                if(etiquetas[i].code == ETIQUETAS.NOMBRE.dataesborrany && numero == 4){
                    if(etiquetas[i].numorder == valor[x].numorder){
                        return valor[x].valor;
                    }
                }
            }
        }
    }

    /**
    * @description
    * Nos devuelve los el array de valores de los tramites para meterlos en el carrusel
    */
    public valoresTramitesPendientes(): any {
        for (let index = 0; index < this.webservicesParseVista.length; index++) {
            const element = this.webservicesParseVista[index];
            if (element.code == CODE_WEBSERVICES.TRAMITSPORTALCIUTADA || 
                element.code == CODE_WEBSERVICES.TRAMITSPORTALEMPRESA || 
                element.code == CODE_WEBSERVICES.TRAMITSPORTALPROVEIDOR) {  
                return element.valores != null && element.valores.length > 0 ? element.valores : null;
            }
        }
        return null;
    }

    /**
    * @description
    * Pasamos el dato específico de los trámites en el carrusel
    * @param valores Array de datos donde están los datos de los trámites
    * @param numero Diferencia a la función del template y determina que nos traemos.
    */
    public recogerValoresTramites(valor: any, numero: number) : any {
        let etiquetas = new Array<Xmlfields>();
        for(let i = 0; i < this.webservicesParseVista.length; i++){
            const element = this.webservicesParseVista[i];
            if (element.code == CODE_WEBSERVICES.TRAMITSPORTALCIUTADA || 
                element.code == CODE_WEBSERVICES.TRAMITSPORTALEMPRESA || 
                element.code == CODE_WEBSERVICES.TRAMITSPORTALPROVEIDOR) {  
                etiquetas = _.cloneDeep(element.etiquetas);
            }
        }
        for(let i = 0; i < etiquetas.length; i++){
            for(let x = 0; x < valor.length; x++){
                if(etiquetas[i].code == ETIQUETAS.NOMBRE.numtramit && numero == 2){
                    if(etiquetas[i].numorder == valor[x].numorder){
                        return valor[x].valor;
                    }
                }
                if(etiquetas[i].code == ETIQUETAS.NOMBRE.desctramit && numero == 1){
                    if(etiquetas[i].numorder == valor[x].numorder){
                        return valor[x].valor;
                    }
                }
                if(etiquetas[i].code == ETIQUETAS.NOMBRE.detTramit && numero == 3){
                    if(etiquetas[i].numorder == valor[x].numorder){
                        return valor[x].valor;
                    }
                }
            }
        }
    }

    /**
    * @description
    * Nos devuelve el array de valores de los Altres serveis para meterlos en el carrusel
    */
    public valoresAltresServeis(): any {
        for (let index = 0; index < this.webservicesParseVista.length; index++) {
          const element = this.webservicesParseVista[index];
            if (element.code == CODE_WEBSERVICES.ALTRESSERVEISCIUTADA || 
                element.code == CODE_WEBSERVICES.ALTRESSERVEISEMPRESA || 
                element.code == CODE_WEBSERVICES.ALTRESSERVEISPROVEIDOR) {  
            return element.valores != null && element.valores.length > 0 ? element.valores : null;
          }
        }
        return null;
    }

    /**
    * @description
    * Pasamos el dato específico de los altres serveis en el carrusel
    * @param valores Array de datos donde están los datos de los trámites
    * @param numero Diferencia a la función del template y determina que nos traemos.
    */
    public recogerValoresAltres(valor: any, numero: number) : any {
        let etiquetas = new Array<Xmlfields>();
        for(let i = 0; i < this.webservicesParseVista.length; i++){
            const element = this.webservicesParseVista[i];
            if (element.code == CODE_WEBSERVICES.ALTRESSERVEISCIUTADA || 
                element.code == CODE_WEBSERVICES.ALTRESSERVEISEMPRESA || 
                element.code == CODE_WEBSERVICES.ALTRESSERVEISPROVEIDOR) {  
                etiquetas = _.cloneDeep(element.etiquetas);
            }
        }
        for(let i = 0; i < etiquetas.length; i++){
            for(let x = 0; x < valor.length; x++){
                if(etiquetas[i].code == ETIQUETAS.NOMBRE.urlServei && numero == 2){
                    if(etiquetas[i].numorder == valor[x].numorder){
                        return valor[x].valor;
                    }
                }
                if(etiquetas[i].code == ETIQUETAS.NOMBRE.descripcio && numero == 1){
                    if(etiquetas[i].numorder == valor[x].numorder){
                        return valor[x].valor;
                    }
                }
                if(etiquetas[i].code == ETIQUETAS.NOMBRE.detall && numero == 3){
                    if(etiquetas[i].numorder == valor[x].numorder){
                        return valor[x].valor;
                    }
                }
            }
        }
    }

    /**
    * @description
    * Nos devuelve los el array de valores de las queixas para meterlos en el carrusel
    */
    public valoresAvis(): any {
        return this.allAvisUser != null && this.allAvisUser.length > 0 ? this.allAvisUser : null;
    }
  
    /**
    * @description
    * Cargamos en la vista rápida los datos de los grafos facturas y contratos (separados por ser lentos)
    * @param code code del WS (Facturas o Contratos, según el usuario seleccione).
    */
    public viewWSCargaLenta(wscode : string){
        let ws = new Wsdefs();
        let datosWs = new Array<WebservicesParse>();

        if(wscode === CODE_WEBSERVICES.PASFACTULTANYWSI){
            this.loadingfactures = true;
            this.viewfactures = true;
        }
        if(wscode === CODE_WEBSERVICES.NIOSDISPONIBLESPROV){
            this.loadingContractes = true;
            this.viewContractes = true;
        }

        let existe : boolean = false;

        for(let i = 0; i < this.wsdefs.length; i++){
            if(this.wsdefs[i].code === wscode){
                ws = _.cloneDeep(this.wsdefs[i]);
            }
        }

        let webser =  this.asignacionAtribObject(ws);
        this.repositoryService.doPost(PETICIONES.webservice.doPost, webser).subscribe(data => {
            datosWs = _.cloneDeep(data);
            for(let x = 0; x < this.webservicesParseVista.length; x++){
                if(this.webservicesParseVista[x].code == datosWs[0].code){
                    existe = true;
                }
            }

            if(!existe){
                this.webservicesParseVista.push(datosWs[0]);
                this.webservicesParse.push(datosWs[0]);
            }

            let numws : number = 0;
            for(let i = 0; i < this.webservicesParseVista.length; i++){
                numws++;
                switch(this.webservicesParseVista[i].code) {
                    case CODE_WEBSERVICES.PASFACTULTANYWSI: {
                        this.vistaRapidaObj.totFacturas = 0;
                        this.vistaRapidaObj.totFacPag = 0;
                        this.vistaRapidaObj.totFacPend = 0;
                        this.vistaRapidaObj.totFacIncid = 0;
                        this.vistaRapidaObj.totImportFact = 0;
                        this.vistaRapidaObj.factpagat = 0;
                        this.vistaRapidaObj.factincid = 0;
                        this.vistaRapidaObj.factpende = 0;
                        let numorden : number = 0;
                        if(this.webservicesParseVista[i].valores != null){
                            this.vistaRapidaObj.totFacturas = this.webservicesParseVista[i].valores.length;
                        }
                        this.calculoImportes(this.webservicesParseVista, CODE_WEBSERVICES.PASFACTULTANYWSI, i, numorden, numws, ETIQUETAS.NOMBRE.importtotal);
                        break; 
                    }

                    case CODE_WEBSERVICES.NIOSDISPONIBLESPROV: {
                        let numorden : number = 0;
                        this.vistaRapidaObj.totContra = 0;
                        this.vistaRapidaObj.totImportContr = 0;
                        this.vistaRapidaObj.contImporFac = 0;
                        this.vistaRapidaObj.contImporNotFac = 0;
                        this.calculoImportes(this.webservicesParseVista, CODE_WEBSERVICES.NIOSDISPONIBLESPROV, i, numorden, numws, ETIQUETAS.NOMBRE.importtotal);
                        if(this.webservicesParseVista[i].valores != null){
                            this.vistaRapidaObj.totContra = this.webservicesParseVista[i].valores.length;
                        }
                        this.vistaRapidaObj.contImporFac = this.vistaRapidaObj.totImportContr - this.vistaRapidaObj.contImporNotFac;
                        break;
                    }
                }
            }
                
            if(wscode === CODE_WEBSERVICES.PASFACTULTANYWSI){
                this.loadingfactures = false;
            }
            if(wscode === CODE_WEBSERVICES.NIOSDISPONIBLESPROV){
                this.loadingContractes = false;
            }

        }, (error: any)=> {
            this.textContacte = true;
            console.log("Error: " + error);
            if(wscode === CODE_WEBSERVICES.PASFACTULTANYWSI){
                this.loadingfactures = false;
            }
            if(wscode === CODE_WEBSERVICES.NIOSDISPONIBLESPROV){
                this.loadingContractes = false;
            }
        });
    }

    /**
    * @description
    * Refrescar la pagina tanto con boton refresco como con selector de terceros
    * @param datdboid dboid del selector, si es pulsando boton refresco el valor es null
    */
    public refrescar(datdboid: any){
        let roluser = this.rol;
        let nifuser = this.nif.toLocaleUpperCase();
        let descuser = this.desc;
        let dboid = "";

        if(datdboid != null){
            dboid =  datdboid;
        }else{
            dboid = this.persons.dboid;
        }

        let tercer = this.tercerApoyo;
        let dato = {rol:roluser, nif:nifuser, desc:descuser, dboid: dboid, tercer: tercer}
        this.initView(dato).subscribe(res => {
            console.log(res);
        }, error => {
            this.router.navigate(['/internal/acces']);
            console.log("Error: " + error);
        });
    }

    /**
    * @description
    * nos redirige a una web para visualizar notif/comun del usuario en vista rápida
    */
    enlaceNotificaciones(): string{
        let url : string = "";
        for(let i = 0; i < this.fieldLinks.length; i++){
            if(this.fieldLinks[i].code === TIPO_DATO.ENOTUM){
                return url = this.fieldLinks[i].url;
            }
        }
        return url;
    }

    /**
    * @description
    * Guardamos un comentario
    * @param comentario
    */
    public enviarcomentario(comentario: string){
    
        let coment = new CommentsInterna();

        this.comment.dboid = this.dboid;
        this.comment.nif = this.nif.toLocaleUpperCase();
        this.comment.login = localStorage.getItem(STORAGE.USUARIO) ?? "";
        this.comment.text = comentario;
        console.log(this.comment);
        this.commentsInternaService.postCommentsInterna(this.comment).subscribe((res: any) => {
            coment = _.cloneDeep(res);
            this.commentsInterna.push(coment);
            this.commentsInterna = _.orderBy(this.commentsInterna, 'createdAt').reverse();
            this.comment.text = "";
        }, (error: any) => {
            console.log("Error: " + error);
        });
    }

    /**
    * @description
    * Desabilita el boton enviar comentarios si no hay comentario
    */
    public deshabilitar():boolean{
        if(this.comment.text === null || this.comment.text === "" ||  this.comment.text === undefined){
        return true;
        }
        return false;
    }

    /**
    * @description
    * Nos traemos todos los trámites disponibles en la Seu y hacemos busqueda en carpeta (ws, campos y datos)
    */
    public cargarTramitsYCarpeta(){

        this.loadingTramite = true;
        this.isTramite = true;
        this.numtramitbusqueda = 0;
        let idioma = localStorage.getItem(LS_LANG) || DEFAULT_LANG;
        this.buscaTramAll = new Array<BuscadorTramites>();

        if(this.tramitsbusqueda != ""){
            this.repositoryService.doGet(PETICIONES.accesTotsTramits.buscaAllTramits + "/" + this.tramitsbusqueda + "/" + idioma).subscribe(res => {
                this.buscaTramAll = _.cloneDeep(res);

                this.numtramitbusqueda = this.buscaTramAll.length;
                for(let i = 0; i < this.buscaTramAll.length; i++){

                    if(this.buscaTramAll[i].titolEs.length <= 0){
                        this.buscaTramAll[i].titolEs = _.cloneDeep(this.buscaTramAll[i].titol);
                    }

                    if(this.buscaTramAll[i].descripcioCurtaEs.length <= 0){
                        this.buscaTramAll[i].descripcioCurtaEs = _.cloneDeep(this.buscaTramAll[i].descripcioCurta);
                    }
                    
                    this.buscaTramAll[i].tramitCorreo =  false;
                    this.buscaTramAll[i].tramitPresencial =  false;
                    this.buscaTramAll[i].tramitTelematic = false;

                    for(let x = 0; x < this.buscaTramAll[i].canals.length; x++){
                        if(this.buscaTramAll[i].canals.length > 0){
                            if(this.buscaTramAll[i].canals[x].charAt(0) == "C"){
                                this.buscaTramAll[i].tramitCorreo = true;
                            }

                            if(this.buscaTramAll[i].canals[x].charAt(0) == "P"){
                                this.buscaTramAll[i].tramitPresencial = true;
                            }

                            if(this.buscaTramAll[i].canals[x].charAt(0) == "T"){
                                this.buscaTramAll[i].tramitTelematic = true;
                            }
                        }
                    }
                }

            }, error => {
                this.loadingTramite = false;
                console.log("Error: " + error);
            });

            if(!this.fullBusca){

                let wsParse : Wsdefs[] = new Array<Wsdefs>();
                for(let i = 0; i < this.wsdefs.length; i++){
                    for(let x = 0; x < this.webservicesParse.length; x++){
                        if(this.wsdefs[i].code === this.webservicesParse[x].code){
                            wsParse.push(this.wsdefs[i]);
                        }
                    }
                }
                
                let wsdefsincarga : Wsdefs[] = new Array<Wsdefs>();
                for(let i = 0; i < this.wsdefsrol.length; i++){
                    let aux: boolean = true;
                    for(let x = 0; x < wsParse.length; x++){
                        if(this.wsdefsrol[i].code === wsParse[x].code){
                            aux = false;
                        }
                    }
                    if(aux){
                        wsdefsincarga.push(this.wsdefsrol[i]);
                    }
                }

                let webser = this.asignacionAtribArrayObject(wsdefsincarga);
                let wsbusquedaCompleta = new Array<WebservicesParse>();
                this.repositoryService.doPost(PETICIONES.webservice.doPost, webser).subscribe(data => {
                    
                    this.formatTipoWS(data);
                    wsbusquedaCompleta = _.cloneDeep(data);

                    let auxparseBusca: WebservicesParse[] = new Array<WebservicesParse>();
                    for(let i = 0; i < this.wsdefs.length; i++){
                        for(let x = 0; x < this.webservicesParse.length; x++){
                            if(this.wsdefs[i].code === this.webservicesParse[x].code){
                                if(this.wsdefs[i].quickview != 1){
                                    auxparseBusca.push(this.webservicesParse[x]);
                                }
                            }
                        }
                    }

                    for(let i = 0; i < wsbusquedaCompleta.length; i++){
                        auxparseBusca.push(wsbusquedaCompleta[i]);
                        this.webservicesParse.push(wsbusquedaCompleta[i]);
                    }

                    this.busquedaCampos(idioma, auxparseBusca);
                    this.tramitsbusqueda = "";
                    this.fullBusca = true;
                    this.loadingTramite = false;
                }, error => {
                    this.tramitsbusqueda = "";
                    this.loadingTramite = false;
                    console.log("Error: " + error);
                });

            }else{

                if(this.fullBusca){
                    let auxparseBusca: WebservicesParse[] = new Array<WebservicesParse>();
                    for(let i = 0; i < this.wsdefs.length; i++){
                        for(let x = 0; x < this.webservicesParse.length; x++){
                            if(this.wsdefs[i].code === this.webservicesParse[x].code){
                                if(this.wsdefs[i].quickview != 1){
                                    auxparseBusca.push(this.webservicesParse[x]);
                                }
                            }
                        }
                    }
                    this.busquedaCampos(idioma, auxparseBusca);
                    this.tramitsbusqueda = "";
                    this.loadingTramite = false;
                }else{
                    this.busquedaCampos(idioma, this.webservicesParseBuscadorAux);
                    this.tramitsbusqueda = "";
                    this.loadingTramite = false;
                }
            }

        }else{
            this.buscaTramAll = new Array<BuscadorTramites>();
            this.webservicesParseBuscador = new Array<WebservicesParse>();
            this.tramitsbusqueda = "";
            this.loadingTramite = false;
        }
    }

    public busquedaCampos(idioma: string, allwsparse: WebservicesParse[]) {
  
        this.webservicesParseBuscador = new Array<WebservicesParse>();
        let webservicesParseBuscador = new Array<WebservicesParse>();
        let text : string = this.tramitsbusqueda
        text != null && text != undefined ? _.deburr(_.trim(text).toLocaleLowerCase()) : "";
        text = _.deburr(_.trim(text));
        
        for(let i = 0; i < allwsparse.length; i++){
          let wsparseaux= new WebservicesParse();
          let xmlfields = new Array<Xmlfields>();
          if(allwsparse[i].valores != null){
            for(let x = 0; x < allwsparse[i].etiquetas.length; x++){
                let campo = _.deburr(_.trim(idioma == "ca" ?  allwsparse[i].etiquetas[x].cat : allwsparse[i].etiquetas[x].esp).toLocaleLowerCase());
                if(text != "" && _.includes(campo, text.toLocaleLowerCase())) {
                    xmlfields.push(allwsparse[i].etiquetas[x]);
                    wsparseaux.code = _.cloneDeep(allwsparse[i].code);
                    wsparseaux.cat = _.cloneDeep(allwsparse[i].cat);
                    wsparseaux.esp = _.cloneDeep(allwsparse[i].esp);
                    wsparseaux.etiquetas = _.cloneDeep(xmlfields);
                    webservicesParseBuscador.push(wsparseaux);
                }
            }
            let registro = _.deburr(_.trim(idioma == "ca" ? allwsparse[i].cat : allwsparse[i].esp).toLocaleLowerCase());
            if(text != "" && _.includes(registro, text.toLocaleLowerCase())) {
                let auxbool: boolean = true;
                for(let x = 0; x < webservicesParseBuscador.length; x++){
                    if(webservicesParseBuscador[x].code === allwsparse[i].code){
                        auxbool = false;
                    }
                }
                if(auxbool){
                    let wsparseaux= new WebservicesParse();
                    wsparseaux = _.cloneDeep(allwsparse[i]);
                    wsparseaux.etiquetas = _.cloneDeep(new Array<Xmlfields>())
                    webservicesParseBuscador.push(wsparseaux);
                }
            }
          }
        }

        for(let i = 0; i < allwsparse.length; i++){
          if(allwsparse[i].valores != null){
            let wsparseaux= new WebservicesParse();
            let xmlfields = new Array<Xmlfields>();
            for(let x = 0; x < allwsparse[i].valores.length; x++){
              for(let y = 0; y < allwsparse[i].valores[x].length; y++){
                let valor = _.deburr(_.trim(allwsparse[i].valores[x][y].valor).toLocaleLowerCase());
                let numorder = allwsparse[i].valores[x][y].numorder;
                if(text != "" && _.includes(valor, text.toLocaleLowerCase())) {
                  for(let t = 0; t < allwsparse[i].etiquetas.length; t++){
                    if(allwsparse[i].etiquetas[t].numorder === numorder){
                      if(allwsparse[i].etiquetas[t].fieldtypeId.format === 0){
                        xmlfields.push(allwsparse[i].etiquetas[t]);
                        wsparseaux.code = _.cloneDeep(allwsparse[i].code);
                        wsparseaux.cat = _.cloneDeep(allwsparse[i].cat);
                        wsparseaux.esp = _.cloneDeep(allwsparse[i].esp);
                        wsparseaux.etiquetas = _.cloneDeep(xmlfields);
                      }
                    }
                  }
                }
              }
            }
            if(wsparseaux.code != undefined){
                let xmlfieldsaux = new Array<Xmlfields>();
                var lookupObject: { [key: string]: Xmlfields } = {};
                for(var x in wsparseaux.etiquetas) {
                    lookupObject[wsparseaux.etiquetas[x].code] = wsparseaux.etiquetas[x];
                }
            
                for(x in lookupObject) {
                    xmlfieldsaux.push(lookupObject[x]);
                }
                wsparseaux.etiquetas = _.cloneDeep(xmlfieldsaux);
                webservicesParseBuscador.push(wsparseaux);
            }
          }
        }

        var lookupObjecto: { [key: string]: WebservicesParse } = {};
        for(var i in webservicesParseBuscador) {
            lookupObjecto[webservicesParseBuscador[i].code] = webservicesParseBuscador[i];
        }

        for(i in lookupObjecto) {
            this.webservicesParseBuscador.push(lookupObjecto[i]);
        }
    
        if(idioma == "ca"){
            this.webservicesParseBuscador = _.orderBy(this.webservicesParseBuscador, 'cat');
        }else{
            this.webservicesParseBuscador = _.orderBy(this.webservicesParseBuscador, 'esp');
        }

        console.log(this.webservicesParseBuscador);
    }

    /**
    * @description
    * Escondemos los tramites de la seu y mostramos la vistarápida o ws segun seleccionemos
    */
    public tramiteout(){
        this.isTramite = false;
        this.vistaRapida = true;
    }

    public createObject<K extends string, T extends {}>(keyName: K, details: T) {
        return { [keyName]: details } as Record<K, T>;
    }

    /**
     * @description
     * Exportamos los datos del ws a un documento csv
     */
    public exportarDatos(): number{

        let numreg = 0;
        for(let y = 0; y < this.webserviceVista.valores[0].length; y++){
            let numorder = this.webserviceVista.valores[0][y].numorder;
            for(let t = 0; t < this.webserviceVista.etiquetas.length; t++){
                if(this.webserviceVista.etiquetas[t].numorder === numorder){
                    if(this.webserviceVista.etiquetas[t].fieldtypeId.format === 0){
                        numreg++;
                    }
                }
            }
        }

        let arraytit = new Array();
        let stringjson = "";
        let jsonPrueba = "";
        for(let x = 0; x < this.webserviceVista.valores.length; x++){
            for(let y = 0; y < this.webserviceVista.valores[x].length; y++){
                let numorder = this.webserviceVista.valores[x][y].numorder;
                for(let t = 0; t < this.webserviceVista.etiquetas.length; t++){
                    if(this.webserviceVista.etiquetas[t].numorder === numorder){
                        if(this.webserviceVista.etiquetas[t].fieldtypeId.format === 0){

                            let clave = "";
                            let valor = this.webserviceVista.valores[x][y].valor;

                            if(this.idioma === DEFAULT_LANG){
                                clave = this.webserviceVista.etiquetas[t].cat;
                            }else{
                                clave = this.webserviceVista.etiquetas[t].esp;
                            }

                            let dynamicObject = new Object();
                            dynamicObject = this.createObject(clave, valor);
                            dynamicObject.toString();

                            if(numreg == 1){
                                jsonPrueba = JSON.stringify(dynamicObject);
                                stringjson = stringjson.concat(jsonPrueba);
                            }else{
                                if(y == 0){
                                    let change = /\}/gi;
                                    jsonPrueba = JSON.stringify(dynamicObject).replace(change, ",");
                                    stringjson = stringjson.concat(jsonPrueba);
                                }else if(y == numreg -1){
                                    let change = /\{/gi;
                                    jsonPrueba = JSON.stringify(dynamicObject).replace(change, "");
                                    stringjson = stringjson.concat(jsonPrueba);
                                }else{
                                    let change1 = /\{/gi;
                                    let change2 = /\}/gi;
                                    jsonPrueba = JSON.stringify(dynamicObject).replace(change1, "").replace(change2, ",");
                                    stringjson = stringjson.concat(jsonPrueba);
                                }
                            }
                    
                            arraytit.push(clave);
                        }
                    }
                }
            }
        }

        if(numreg == 0){
            return 0;
        }else{
            const arraytitulos = arraytit.slice(0, numreg);

            let jsoncorch = "[" + stringjson + "]";
            let change = /\}{/gi;
            let salto = /\\n/gi;
            let puntocoma = /\;/gi;
            
            let json = jsoncorch.replace(change, "},{");
            json = json.replace(salto, ". ");
            json = json.replace(puntocoma, ",");

            let titulo = "";
            let fecha = Utils.formatofecha();
            if(this.idioma === DEFAULT_LANG){
                titulo = Utils.formatoFirstCase(this.webserviceVista.cat);
            }else{
                titulo = Utils.formatoFirstCase(this.webserviceVista.esp);
            }

            let nombrefichero = this.nif + titulo + fecha;
            this.downloadFile(json, nombrefichero, arraytitulos);
            return 1;
        }
        
    }

    /**
    * @description
    * Ganeración de ldcumento GSV con los datos de las tablas
    */
    downloadFile(data: any, filename='data', arraytitulos:any) {
        let csvData = this.ConvertToCSV(data, arraytitulos);
        let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
        let dwldLink = document.createElement("a");
        let url = URL.createObjectURL(blob);
        let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
        if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
            dwldLink.setAttribute("target", "_blank");
        }
        dwldLink.setAttribute("href", url);
        dwldLink.setAttribute("download", filename + ".csv");
        dwldLink.style.visibility = "hidden";
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);
    }

    /**
    * @description
    * Conversion de los datos de las tablas para pasarlos al documento CSV, añadimos titulos en cabezera.
    */
    ConvertToCSV(objArray: any, headerList: any) {
        let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        let str = '';
        let row = 'registro' + ';';

        for (let index in headerList) {
            row += headerList[index] + ';';
        }
        row = row.slice(0, -1);
        str += row + '\r\n';
        for (let i = 0; i < array.length; i++) {
            let line = (i+1)+'';
            for (let index in headerList) {
                let head = headerList[index];
                line += ';' + array[i][head];
            }
            str += line + '\r\n';
        }
        return str;
    }

    /**
     * @description
     * Recoge el icono seleccionado de cada limk y lo introduce en las vistas
     * @param webservicesParse datos del wsparse correspondiente
     */
    gestionIconos(webservicesParse: WebservicesParse){
        for (let x = 0; x < webservicesParse.etiquetas.length; x++) {
            for (let y = 0; y < this.fieldLinks.length; y++) {
                if(this.fieldLinks[y].xmlfields.length > 0){
                for (let z = 0; z < this.fieldLinks[y].xmlfields.length; z++) {
                    if(webservicesParse.etiquetas[x].id == this.fieldLinks[y].xmlfields[z].id){
                    webservicesParse.etiquetas[x].fieldtypeId.unit = _.cloneDeep(this.fieldLinks[y].icon);
                    }
                }
                }
            }
        }
    }

    /**
     * @description
     * Recogemos el valor del string del icono del filedlink y le pasamos la ruta a la vista
     * para que lo cargue
     */
    public seleccionIcono(tipo:String):String{
        return BASE_HREF + '/assets/images/icons/' + tipo + '.svg';
    }

    decodeHtmlEntities(value: string): string {
        const txt = document.createElement('textarea');
        txt.innerHTML = value;
        return txt.value;
    }

    build() {}

}
